import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { useApp } from '../../../context/AppContext';
import vacacionesService from '../../../api/vacacionesService';
import permisosService from '../../../api/permisosService'; 
import empleadosService from '../../../api/empleadosService';
import { Calendar, Plus, Clock, Check, X, FileText, Users, ArrowRight, AlertTriangle, Edit, Package, Info, KeyRound, CheckCircle, XCircle, Award, Mail, Ban, CalendarCheck, CalendarX, CalendarDays, UserCheck, Cake, FileSpreadsheet, Download, Upload, Search } from 'lucide-react';
import { showNotification } from '@mantine/notifications';
import { MOSTRAR_BALANCE_PERMISOS, permisosDelAnoCargados } from '../../../utils/featureFlags';
import { parseFechaLocal, fechaISOLocal, formatearFechaISO } from '../../../utils/fechas';
import DiasFeriados from './DiasFeriados';

const p2 = (n) => String(n).padStart(2, '0');
const isoDe = (d) => `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`;

const TIPOS_DESIGNACION = { feria: 'Feria', mision: 'Misión', otro: 'Otra actividad' };
const DESIGNACION_VACIA = {
  tipo: 'feria', evento: '', fechaEventoInicio: '', fechaEventoFin: '',
  diasOtorgados: '', fechaVencimiento: '', observaciones: '', habilitar: false
};

// Tarjeta de indicador de la cabecera de Autoservicio: ícono, etiqueta y cifra.
const TarjetaIndicador = ({ icono: Icono, color, etiqueta, valor, children }) => (
  <div style={{
    background: 'white',
    borderRadius: '0.75rem',
    border: '1px solid #e5e7eb',
    boxShadow: '0 1px 2px rgba(15,23,42,0.06)',
    padding: '1.1rem 1.25rem',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.9rem'
  }}>
    <span style={{ width: '2.75rem', height: '2.75rem', borderRadius: '0.75rem', background: `${color}14`, color, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <Icono size={22} />
    </span>
    <div style={{ minWidth: 0 }}>
      <p style={{ margin: 0, fontSize: '0.72rem', fontWeight: '600', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{etiqueta}</p>
      <p style={{ margin: '0.15rem 0 0', fontSize: '1.75rem', fontWeight: '700', color: '#0f172a', lineHeight: 1.2 }}>{valor}</p>
      {children && <div style={{ marginTop: '0.35rem' }}>{children}</div>}
    </div>
  </div>
);

const VacacionesModule = () => {
  const { user } = useAuth();
 // const { showNotification } = useApp();  //  Solo obtener showNotification
   
 // const notify = (message, type = 'info') => {
  //  if (showNotification) {
   //   showNotification({ type, message });
   // } else {
   //   console.warn('showNotification no disponible:', message);
  //  }
 // };

  // ✅ LOGS DETALLADOS
  console.log('🔍 Usuario completo:', user);
  console.log('🔍 ROL DEL USUARIO:', user.role);
  console.log('🔍 ROL NORMALIZADO:', user.role?.toLowerCase().replace(/\s+/g, '_'));

  const [activeTab, setActiveTab] = useState('solicitar');
  const [loading, setLoading] = useState(false);
  
  // Estados principales
  const [solicitudes, setSolicitudes] = useState([]);
  const [estadisticas, setEstadisticas] = useState({
    diasTotales: 0,
    diasUsados: 0,
    diasDisponibles: 0
  });

  const [solicitudSeleccionada, setSolicitudSeleccionada] = useState(null);
  const [mostrarModalAprobacion, setMostrarModalAprobacion] = useState(false);
  const [mostrarModalRechazo, setMostrarModalRechazo] = useState(false);

  const [periodos, setPeriodos] = useState([]);
  const [balancePermisos, setBalancePermisos] = useState([]);
  // Feriados (no cuentan en la solicitud) y ventana de 30 días del cumpleaños
  const [feriados, setFeriados] = useState([]);
  const [miCumpleanos, setMiCumpleanos] = useState(null);

  // Días por designación (ferias, misiones)
  const [misDesignaciones, setMisDesignaciones] = useState([]);
  const [designaciones, setDesignaciones] = useState([]);
  const [designacionForm, setDesignacionForm] = useState(DESIGNACION_VACIA);
  const [busquedaDesignacion, setBusquedaDesignacion] = useState('');
  const [modoDesignacion, setModoDesignacion] = useState('seleccion'); // 'seleccion' | 'excel'
  const [seleccionadosDesignacion, setSeleccionadosDesignacion] = useState([]); // [{ empleadoId, nombre, puesto }]
  const [excelDesignacion, setExcelDesignacion] = useState(null); // { archivo, colaboradores, errores, totalErrores }
  const [leyendoExcelDesignacion, setLeyendoExcelDesignacion] = useState(false);
  const [guardandoDesignacion, setGuardandoDesignacion] = useState(false);
  const diasDesignacion = misDesignaciones
    .filter(d => d.estado === 'Habilitada' && !d.vencida)
    .reduce((sum, d) => sum + Number(d.diasDisponibles || 0), 0);

  // Recordatorio a líderes (RRHH)
  const [recordatorios, setRecordatorios] = useState(null);
  const [correoPruebaRecordatorio, setCorreoPruebaRecordatorio] = useState('');
  const [enviandoRecordatorio, setEnviandoRecordatorio] = useState(false);

  const diasDisponibles = periodos.length > 0 
  ? periodos.reduce((sum, p) => sum + p.diasDisponibles, 0)
  : estadisticas?.diasDisponibles || 0;
  const diasUsados = estadisticas?.diasUsados || 0;
  const diasTotales = estadisticas?.diasTotales || 0;
  const diasPendientes = estadisticas?.diasPendientes || 0;

  // Modal de aprobación manual
  const [showManualModal, setShowManualModal] = useState(false);
  const [manualApprovalData, setManualApprovalData] = useState({
    solicitudId: null,
    motivo: '',
    accion: 'aprobada'
  });

  // Modal de selección de períodos
  const [showPeriodosModal, setShowPeriodosModal] = useState(false);
  const [periodosSeleccionados, setPeriodosSeleccionados] = useState([]);

  // Formulario de solicitud
  const [solicitudForm, setSolicitudForm] = useState({
    fechaInicio: '',
    fechaFin: '',
    motivo: '',
    tipo: 'vacaciones'
  });

  // Estados para entrada manual
  const [empleados, setEmpleados] = useState([]);
  const [empleadoBusqueda, setEmpleadoBusqueda] = useState('');
  const [mostrarListaEmpleados, setMostrarListaEmpleados] = useState(false);
  const [entradaManualForm, setEntradaManualForm] = useState({
    empleadoId: null,
    empleadoNombre: '',
    tipoSolicitud: 'vacaciones',
    fechaInicio: '',
    fechaFin: '',
    justificacion: '',
    documentoReferencia: ''
  });

  // Roles con aprobación manual (RRHH)
  const ROLES_APROBACION_MANUAL = ['dths_analista', 'dths_coordinador', 'dths_gerente', 'dths_director']

  const ROLES_LABELS = {
  'colaborador': 'Colaborador',
  'coordinador': 'Coordinador',
  'gerente': 'Gerente',
  'director': 'Director',
  'dths_analista': 'Analista DTHS',
  'dths_coordinador': 'Coordinador DTHS',
  'dths_gerente': 'Gerente DTHS',
  'dths_director': 'Director DTHS'
};

// Función para mostrar notificaciones (usa los helpers globales si existen)
  

  // Función para recargar las solicitudes
  const cargarSolicitudes = async () => {
    try {
      const response = await vacacionesService.obtenerSolicitudes();
      setSolicitudes(response.data || []);
    } catch (error) {
      showNotification('Error al cargar las solicitudes', 'error');
    }
  };

  const cargarEmpleados = async () => {
  console.log('🔧 [1] cargarEmpleados() iniciando...');
  
  try {
    console.log('📡 [2] Llamando a empleadosService.getEmpleados()...');
    const response = await empleadosService.getEmpleados();
    
    console.log('✅ [3] Respuesta recibida:', response);
    console.log('✅ [4] response.empleados:', response.empleados?.length || 0, 'empleados');
    
    // ✅ CORRECCIÓN: Los datos están en response.empleados, no en response.data
    if (response.empleados && Array.isArray(response.empleados)) {
      setEmpleados(response.empleados);
     console.log('✅ [5] Empleados cargados correctamente:', response.empleados.length);
      console.log('📋 [6] Primer empleado COMPLETO:', response.empleados[0]);
      console.log('📋 [7] Propiedades:', Object.keys(response.empleados[0]));
    } else {
      console.warn('⚠️ response.empleados no es un array');
      setEmpleados([]);
    }
    
  } catch (error) {
    console.error('❌ Error al cargar empleados:', error);
    showNotification({
      title: 'Error',
      message: 'Error al cargar lista de empleados',
      color: 'red'
    });
    setEmpleados([]);
  }
};

  // Cargar datos al montar
  useEffect(() => {
    if (user?.empleadoId) {
      cargarDatos();
      cargarMisDesignaciones();
    }
  }, [user]);

  const cargarMisDesignaciones = async () => {
    try {
      setMisDesignaciones(await vacacionesService.getMisDesignaciones(user.empleadoId));
    } catch (error) {
      console.error('Error al cargar designaciones:', error);
      setMisDesignaciones([]);
    }
  };

  const cargarDesignaciones = async () => {
    try {
      setDesignaciones(await vacacionesService.getDesignaciones());
    } catch (error) {
      showNotification({ title: 'Error', message: 'No se pudieron cargar las designaciones', color: 'red' });
    }
  };

  const limpiarDesignacion = () => {
    setDesignacionForm(DESIGNACION_VACIA);
    setBusquedaDesignacion('');
    setSeleccionadosDesignacion([]);
    setExcelDesignacion(null);
  };

  const leerExcelDesignacion = async (archivo) => {
    if (!archivo) return;
    setLeyendoExcelDesignacion(true);
    try {
      const r = await vacacionesService.leerExcelDesignaciones(archivo);
      setExcelDesignacion({ archivo: archivo.name, ...r });
      if (!r.colaboradores.length) {
        showNotification({ title: 'Sin datos', message: 'El archivo no tiene colaboradores con días a otorgar', color: 'orange' });
      }
    } catch (error) {
      setExcelDesignacion(null);
      showNotification({ title: 'Error', message: error.response?.data?.error || 'No se pudo leer el archivo', color: 'red' });
    } finally {
      setLeyendoExcelDesignacion(false);
    }
  };

  const descargarPlantillaDesignacion = async () => {
    try {
      await vacacionesService.descargarPlantillaDesignaciones();
    } catch (error) {
      showNotification({ title: 'Error', message: error.response?.data?.error || 'No se pudo descargar la plantilla', color: 'red' });
    }
  };

  const guardarDesignacion = async () => {
    const f = designacionForm;
    const colaboradores = modoDesignacion === 'excel'
      ? (excelDesignacion?.colaboradores || []).map(c => ({ empleadoId: c.empleadoId, dias: c.dias }))
      : seleccionadosDesignacion.map(c => ({ empleadoId: c.empleadoId, dias: Number(f.diasOtorgados) }));
    if (!f.evento.trim()) {
      showNotification({ title: 'Faltan datos', message: 'Indique la feria, misión o actividad', color: 'red' });
      return;
    }
    if (!colaboradores.length) {
      showNotification({ title: 'Faltan datos', message: modoDesignacion === 'excel' ? 'Suba la plantilla con los días de cada colaborador' : 'Agregue al menos un colaborador', color: 'red' });
      return;
    }
    if (modoDesignacion === 'seleccion' && !(Number(f.diasOtorgados) > 0)) {
      showNotification({ title: 'Faltan datos', message: 'Indique los días a otorgar', color: 'red' });
      return;
    }
    setGuardandoDesignacion(true);
    try {
      const { diasOtorgados, ...evento } = f;
      const r = await vacacionesService.crearDesignacion({ ...evento, colaboradores });
      showNotification({ title: 'Listo', message: r.message, color: r.omitidos?.length ? 'orange' : 'green' });
      limpiarDesignacion();
      cargarDesignaciones();
    } catch (error) {
      showNotification({ title: 'Error', message: error.response?.data?.error || 'No se pudo registrar la designación', color: 'red' });
    } finally {
      setGuardandoDesignacion(false);
    }
  };

  const cambiarEstadoDesignacion = async (id, accion) => {
    try {
      const r = accion === 'habilitar'
        ? await vacacionesService.habilitarDesignacion(id)
        : await vacacionesService.anularDesignacion(id);
      showNotification({ title: 'Listo', message: r.message, color: 'green' });
      cargarDesignaciones();
    } catch (error) {
      showNotification({ title: 'Error', message: error.response?.data?.error || 'No se pudo actualizar la designación', color: 'red' });
    }
  };

  const verRecordatorios = async () => {
    try {
      setRecordatorios(await vacacionesService.getVistaPreviaRecordatorios());
    } catch (error) {
      showNotification({ title: 'Error', message: error.response?.data?.error || 'No se pudo calcular el recordatorio', color: 'red' });
    }
  };

  const enviarRecordatoriosAhora = async () => {
    const prueba = correoPruebaRecordatorio.trim();
    if (!prueba && !window.confirm('Se enviará el recordatorio a todos los líderes con solicitudes pendientes. ¿Continuar?')) return;
    setEnviandoRecordatorio(true);
    try {
      const r = await vacacionesService.enviarRecordatorios(prueba || undefined);
      showNotification({
        title: prueba ? 'Correos de prueba enviados' : 'Recordatorio enviado',
        message: `${r.enviados} correo(s) enviado(s)${r.sinCorreo.length ? `, ${r.sinCorreo.length} sin correo registrado` : ''}${r.fallidos.length ? `, ${r.fallidos.length} fallido(s)` : ''}.`,
        color: r.fallidos.length ? 'orange' : 'green'
      });
    } catch (error) {
      showNotification({ title: 'Error', message: error.response?.data?.error || 'No se pudo enviar el recordatorio', color: 'red' });
    } finally {
      setEnviandoRecordatorio(false);
    }
  };

  const cargarFeriados = () => {
    const anio = new Date().getFullYear();
    vacacionesService.getFeriados(`${anio}-01-01`, `${anio + 1}-12-31`).then(setFeriados).catch(() => setFeriados([]));
  };

  const cargarDatos = async () => {
  try {
    setLoading(true);
    
    const solicitudesData = await vacacionesService.getSolicitudes(user.id, user.rawRole);
    setSolicitudes(solicitudesData);
    
    // Cargar estadísticas detalladas
    const statsData = await vacacionesService.getEstadisticasDetalladas(user.empleadoId);
    console.log('Estadísticas recibidas:', statsData);
    
    // Validar que exista el objeto totales
    if (statsData.totales) {
      setEstadisticas(statsData.totales);
    } else {
      // Fallback si no existe
      setEstadisticas({
        diasTotales: 0,
        diasUsados: 0,
        diasDisponibles: 0,
        diasPendientes: 0
      });
    }
    
    setPeriodos(statsData.periodos || []);
    const balanceData = await permisosService.getBalanceEmpleado(user.empleadoId);
    setBalancePermisos(balanceData);
    cargarFeriados();
    vacacionesService.getMiCumpleanos().then(setMiCumpleanos).catch(() => setMiCumpleanos(null));
  } catch (error) {
    // 404 = el empleado todavía no tiene balance de vacaciones cargado
    // (aún no cumple su primer año de antigüedad, o RRHH no se lo ha generado).
    // Es un estado vacío legítimo, no un error real: no debe asustar al usuario.
    const esSinBalance = error?.response?.status === 404;
    if (!esSinBalance) {
      showNotification('Error al cargar datos de vacaciones', 'error');
    }
    console.error('Error:', error);

    // Establecer valores por defecto (tanto para el caso sin balance como para error real)
    setEstadisticas({
      diasTotales: 0,
      diasUsados: 0,
      diasDisponibles: 0,
      diasPendientes: 0
    });
    setPeriodos([]);
  } finally {
    setLoading(false);
  }
};

  // Días laborables (lunes a viernes, sin feriados) entre las fechas del
  // formulario. El backend hace el mismo cálculo y es el que vale.
  const calcularDias = () => calcularDiasHabiles();

  const contarLaborables = (desde, hasta) => {
    const inicio = parseFechaLocal(desde);
    const fin = parseFechaLocal(hasta);
    if (!inicio || !fin || fin < inicio) return 0;
    const libres = new Set(feriados.map(f => f.fecha));
    let dias = 0;
    for (const d = new Date(inicio); d <= fin; d.setDate(d.getDate() + 1)) {
      const diaSemana = d.getDay();
      if (diaSemana !== 0 && diaSemana !== 6 && !libres.has(isoDe(d))) dias++;
    }
    return dias;
  };

  const calcularDiasHabiles = () => contarLaborables(solicitudForm.fechaInicio, solicitudForm.fechaFin);

  // Feriados de lunes a viernes dentro del rango elegido (no se cuentan)
  const feriadosEnRango = () => {
    if (!solicitudForm.fechaInicio || !solicitudForm.fechaFin) return [];
    return feriados.filter(f => {
      const dia = parseFechaLocal(f.fecha).getDay();
      return f.fecha >= solicitudForm.fechaInicio && f.fecha <= solicitudForm.fechaFin && dia !== 0 && dia !== 6;
    });
  };

  const esCumpleanos = solicitudForm.tipo === 'cumpleaños';

  // Abrir modal de períodos
  // Abrir modal de períodos
const abrirModalPeriodos = () => {
  console.log('🔧 Abriendo modal de períodos');
  console.log('📋 Períodos disponibles:', periodos);
  
  try {
    const diasSolicitados = calcularDias();
    const seleccionInicial = [];
    let diasRestantes = diasSolicitados;
    
    for (const periodo of periodos) {
      if (diasRestantes <= 0) break;
      
      // ✅ Normalizar nombres de campos (SQL Server usa MAYÚSCULAS, JS usa camelCase)
      const balanceId = periodo.balanceId || periodo.BalanceID || periodo.id;
      const diasDisponibles = periodo.diasDisponibles || periodo.DiasDisponibles || periodo.DiasPendientes;
      const descripcion = periodo.descripcion || periodo.Descripcion || 
                         `${periodo.anioInicio || periodo.AnioInicio}-${periodo.anioFin || periodo.AnioFin}`;
      
      if (!balanceId) {
        console.error('⚠️ Período sin balanceId:', periodo);
        continue;
      }
      
      const diasAUsar = Math.min(diasRestantes, diasDisponibles);
      
      if (diasAUsar > 0) {
        seleccionInicial.push({
          balanceId: balanceId,
          descripcion: descripcion,
          diasDisponibles: diasDisponibles,
          dias: diasAUsar
        });
        diasRestantes -= diasAUsar;
        console.log(`✅ Período agregado: ${descripcion} - ${diasAUsar} días`);
      }
    }
    
    console.log('📦 Selección inicial:', seleccionInicial);
    setPeriodosSeleccionados(seleccionInicial);
    setShowPeriodosModal(true);
  } catch (error) {
  console.error('❌ Error en abrirModalPeriodos:', error);
  showNotification({
    type: 'error',
    message: 'Error al abrir selección de períodos'
  });
}
};


  // Actualizar días de un período seleccionado
  const actualizarDiasPeriodo = (balanceId, nuevosDias) => {
    setPeriodosSeleccionados(prev => 
      prev.map(p => p.balanceId === balanceId ? { ...p, dias: parseInt(nuevosDias) || 0 } : p)
    );
  };

  // Calcular total de días seleccionados
  const calcularTotalSeleccionado = () => {
    return periodosSeleccionados.reduce((sum, p) => sum + p.dias, 0);
  };

  // Crear solicitud con períodos
 // Crear solicitud con períodos
const handleSubmitSolicitud = async (e) => {
  e.preventDefault();
  
  console.log('=== DEBUG SUBMIT ===');
  console.log('Tipo solicitud:', solicitudForm.tipo);
  console.log('Cantidad de períodos:', periodos.length);
  console.log('Períodos:', periodos);
  
  if (!solicitudForm.fechaInicio || !solicitudForm.fechaFin || !solicitudForm.motivo.trim()) {
  showNotification('Por favor completa todos los campos obligatorios', 'error');
  return;
}


  // REEMPLAZA por:
const inicio = new Date(solicitudForm.fechaInicio + 'T00:00:00');
const fin = new Date(solicitudForm.fechaFin + 'T00:00:00');
const hoy = new Date();
hoy.setHours(0, 0, 0, 0);

if (fin < inicio) {
  showNotification({ type: 'error', message: 'La fecha de fin no puede ser anterior a la fecha de inicio' });
  return;
}

if (inicio <= hoy) {
  showNotification({ type: 'error', message: 'La fecha de inicio debe ser futura' });
  return;
}

const diasSolicitados = calcularDias();

if (diasSolicitados > diasDisponibles && solicitudForm.tipo === 'vacaciones') {
  showNotification({
    type: 'error',
    message: `No tienes suficientes días disponibles. Solicitas ${diasSolicitados} días pero solo tienes ${diasDisponibles} disponibles.`
  });
  return;
}

if (solicitudForm.tipo === 'cumpleaños' && miCumpleanos?.tieneFechaNacimiento && miCumpleanos.habilitada &&
    (solicitudForm.fechaInicio < miCumpleanos.desde || solicitudForm.fechaInicio > miCumpleanos.hasta)) {
  showNotification({
    type: 'error',
    message: `El día de cumpleaños solo puede tomarse entre el ${formatearFechaISO(miCumpleanos.desde)} y el ${formatearFechaISO(miCumpleanos.hasta)}.`
  });
  return;
}

if (solicitudForm.tipo === 'permiso' || solicitudForm.tipo === 'cumpleaños') {
  const tipoPermiso = solicitudForm.tipo === 'permiso' ? 'permiso_personal' : 'cumpleanos';
  const balancePermiso = balancePermisos.find(bp => bp.TipoPermiso === tipoPermiso);
  const diasDisponiblesPermiso = solicitudForm.tipo === 'cumpleaños' && miCumpleanos?.habilitada
    ? miCumpleanos.disponibles
    : (balancePermiso?.DiasDisponibles ?? 0);
  if (diasSolicitados > diasDisponiblesPermiso) {
    showNotification({
      type: 'error',
      message: `No tienes días disponibles de ${solicitudForm.tipo === 'permiso' ? 'permiso personal' : 'cumpleaños'}. Disponibles: ${diasDisponiblesPermiso}`
    });
    return;
  }
}

if (solicitudForm.tipo === 'designacion' && diasSolicitados > diasDesignacion) {
  showNotification({
    type: 'error',
    message: `No tienes suficientes días por designación habilitados. Solicitas ${diasSolicitados} y tienes ${diasDesignacion}.`
  });
  return;
}


  console.log('¿Abrir modal?', solicitudForm.tipo === 'vacaciones' && periodos.length > 1);
  
  if (solicitudForm.tipo === 'vacaciones' && periodos.length > 1) {
    console.log('ABRIENDO MODAL');
    abrirModalPeriodos();
    return;
  }

  console.log('Crear solicitud directa');
  await crearSolicitudDirecta();
};

  const crearSolicitudDirecta = async () => {
  setLoading(true);

  try {
    const diasSolicitados = calcularDias();

    // Llamada al servicio para crear la solicitud
    await vacacionesService.crearSolicitud({
      empleadoId: user.empleadoId,
      tipo: solicitudForm.tipo,
      fechaInicio: solicitudForm.fechaInicio,
      fechaFin: solicitudForm.fechaFin,
      dias: diasSolicitados,
      diasHabiles: calcularDiasHabiles(),
      motivo: solicitudForm.motivo,
    });

    // Recargar datos después de crear la solicitud
    await cargarDatos();

    // Notificación de éxito
    showNotification({
      title: 'Éxito',
      message: `Solicitud de ${diasSolicitados} días enviada correctamente.`,
      color: 'green',
    });

    // Reiniciar formulario
    setSolicitudForm({
      fechaInicio: '',
      fechaFin: '',
      motivo: '',
      tipo: 'vacaciones',
    });

  } catch (error) {
    // Notificación de error
    showNotification({
      title: 'Error',
      message: 'Error al crear solicitud: ' + (error.response?.data?.error || error.message),
      color: 'red',
    });

  } finally {
    setLoading(false);
  }
};


const confirmarSolicitudConPeriodos = async () => {
  const diasSolicitados = calcularDias();
  const totalSeleccionado = calcularTotalSeleccionado();

  if (totalSeleccionado !== diasSolicitados) {
  showNotification({
    title: 'Atención',
    message: `La suma de días seleccionados (${totalSeleccionado}) debe ser igual a los días solicitados (${diasSolicitados})`,
    color: 'yellow', 
  });
  return;
}


  try {
    setLoading(true);

    await vacacionesService.crearSolicitudConPeriodos({
      empleadoId: user.empleadoId,
      tipo: solicitudForm.tipo,
      fechaInicio: solicitudForm.fechaInicio,
      fechaFin: solicitudForm.fechaFin,
      dias: diasSolicitados,
      diasHabiles: calcularDiasHabiles(),
      motivo: solicitudForm.motivo,
      periodosSeleccionados: periodosSeleccionados.map(p => ({
        balanceId: p.balanceId,
        dias: p.dias
      }))
    });

    // Resetear formulario ANTES de recargar datos
    setSolicitudForm({
      fechaInicio: '',
      fechaFin: '',
      motivo: '',
      tipo: 'vacaciones'
    });
    
    setShowPeriodosModal(false);
    setPeriodosSeleccionados([]);
    
    // Recargar datos al final
    await cargarDatos();

    
  // Mostrar mensaje de éxito
  showNotification({
    title: 'Éxito',
    message: `Solicitud de ${diasSolicitados} días enviada correctamente.`,
    color: 'green',
  });

    } catch (error) {
  console.error('Error:', error);
  showNotification({
    title: 'Error',
    message: 'Error al crear solicitud: ' + (error?.response?.data?.error || error?.message || 'Error desconocido'),
    color: 'red',
  });
    } finally {
      setLoading(false);
    }

};

  const handleManualApproval = async () => {
  if (!manualApprovalData.motivo.trim()) {
    showNotification({
      title: 'Atención',
      message: 'Debes proporcionar un motivo para la aprobación manual',
      color: 'red', // 'red' para error
    });
    return;
  }

  try {
    setLoading(true);
    await vacacionesService.procesarSolicitud(manualApprovalData.solicitudId, {
      usuarioID: user.id,
      accion: manualApprovalData.accion,
      esManual: true,
      motivoManual: manualApprovalData.motivo
    });

    // Notificación de éxito
      showNotification({
        title: 'Éxito',
        message:
          manualApprovalData.accion === 'aprobada'
            ? 'Solicitud aprobada manualmente'
            : 'Solicitud rechazada manualmente',
        color: 'green',
      });

    await cargarDatos();
  } catch (error) {
  // Notificación de error
  showNotification({
    title: 'Error',
    message: 'Error al procesar: ' + (error.response?.data?.error || error.message),
    color: 'red',
  });
  } finally {
    setLoading(false);
  }

  setShowManualModal(false);
  setManualApprovalData({
    solicitudId: null,
    motivo: '',
    accion: 'aprobada'
  });

};

  const openManualModal = (solicitudId, accion = 'aprobada') => {
    setManualApprovalData({
      solicitudId,
      motivo: '',
      accion
    });
    setShowManualModal(true);
  };

  // Verificar si puede aprobar
 // Verificar si puede aprobar
const puedeAprobar = (solicitud) => {
  if (!solicitud.flujoAprobacion || !Array.isArray(solicitud.flujoAprobacion)) {
    console.log('❌ Sin flujo o no es array:', {
      solicitudId: solicitud.id,
      tieneFlujo: !!solicitud.flujoAprobacion,
      esArray: Array.isArray(solicitud.flujoAprobacion)
    });
    return { puede: false };
  }
  
  // Encontrar el primer nivel pendiente (sin accion)
  console.log('📋 Total solicitudes recibidas:', solicitudes.length);
if (solicitudes.length > 0) {
  console.log('📋 Primera solicitud:', JSON.stringify(solicitudes[0]));
}
  const nivelPendiente = solicitud.flujoAprobacion.find(nivel => !nivel.accion);
  
  if (!nivelPendiente) {
    console.log('⏭️ No hay niveles pendientes (todo aprobado/rechazado):', {
      solicitudId: solicitud.id,
      niveles: solicitud.flujoAprobacion.map(n => ({rol: n.rol, accion: n.accion}))
    });
    return { puede: false };
  }
  
  // Normalizar roles para comparación
  const rolUsuario = user.rawRole?.toLowerCase();
  const rolPendiente = nivelPendiente.rol?.toLowerCase().replace(/\s+/g, '_');
  
  console.log('🔍 puedeAprobar:', {
    solicitudId: solicitud.id,
    empleado: solicitud.empleado,
    rolUsuario,
    rolPendiente,
    coincide: rolUsuario === rolPendiente,
    flujo: solicitud.flujoAprobacion.map(n => ({rol: n.rol, accion: n.accion}))
  });
  
  // Si el rol del usuario coincide con el nivel pendiente
 // Si el rol del usuario coincide con el nivel pendiente
  if (rolUsuario === rolPendiente) {
    console.log('✅ PUEDE APROBAR - Rol coincide');
    return { puede: true, motivo: 'normal' };
  }

  // Caso especial: dths_director puede aprobar nivel 'director' como aprobación normal
  if (rolUsuario === 'dths_director' && rolPendiente === 'director') {
    console.log('✅ PUEDE APROBAR - dths_director aprueba nivel director');
    return { puede: true, motivo: 'normal' };
  }
  
  // RRHH puede hacer aprobación manual
  if (ROLES_APROBACION_MANUAL.includes(user.rawRole)) {
    console.log('✅ PUEDE APROBAR - Aprobación manual (RRHH)');
    return { puede: true, motivo: 'manual' };
  }
  
  console.log('❌ NO PUEDE APROBAR');
  return { puede: false };
};

  // Obtener solicitudes pendientes
  const esRRHH = ROLES_APROBACION_MANUAL.includes(user.rawRole?.toLowerCase());

  const solicitudesPendientes = solicitudes.filter(sol => {
    if (sol.estado?.toLowerCase() !== 'pendiente') return false;
    if (esRRHH) return true; // RRHH ve todas las pendientes para intervenir si es necesario
    const permisos = puedeAprobar(sol);
    return permisos.puede;
  });

  const getEstadoColor = (estado) => {
    switch (estado) {
      case 'aprobada': return { bg: '#f0fdf4', color: '#166534', border: '#bbf7d0' };
      case 'rechazada': return { bg: '#fef2f2', color: '#dc2626', border: '#fecaca' };
      case 'pendiente': return { bg: '#fff7ed', color: '#ea580c', border: '#fed7aa' };
      default: return { bg: '#f9fafb', color: '#374151', border: '#e5e7eb' };
    }
  };

  const getTipoLabel = (tipo) => {
    switch (tipo) {
      case 'vacaciones': return 'Vacaciones';
      case 'permiso': return 'Permiso Personal';
    {/*   case 'medico': return 'Permiso Médico';*/}
      default: return tipo;
    }
  };

  const getEtiquetaVista = () => {
    switch (user.role) {
      case 'Director RRHH':
      case 'Gerente RRHH':
        return 'Vista Global Completa - Toda la Empresa';
      case 'RRHH':
        return 'Vista RRHH - Gerentes y Colaboradores';
      case 'Director':
        return 'Vista Directiva - Gerentes y Colaboradores';
      case 'Gerente':
        return 'Vista Gerencial - Colaboradores Directos';
      default:
        return 'Vista Personal - Mis Solicitudes';
    }
  };

  const FlujAprobacion = ({ flujo, estado, aprobacionManual }) => {
  if (!flujo || !Array.isArray(flujo) || flujo.length === 0) return null;
  
  return (
    <div style={{ marginTop: '1rem', padding: '1rem', background: '#f8fafc', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
        <h5 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#374151', margin: 0 }}>
          Flujo de Aprobación
        </h5>
        {aprobacionManual && (
          <span style={{
            padding: '0.25rem 0.5rem',
            borderRadius: '9999px',
            fontSize: '0.625rem',
            fontWeight: '600',
            background: '#fef3c7',
            color: '#92400e',
            border: '1px solid #fcd34d'
          }}>
            APROBACIÓN MANUAL
          </span>
        )}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
        {flujo.map((nivel, index) => {
          const isCompleted = nivel.accion !== null;
          const isCurrent = nivel.accion === null && 
                           (index === 0 || flujo[index - 1]?.accion !== null);
          
          return (
            <React.Fragment key={nivel.orden || index}>
              <div style={{
                padding: '0.25rem 0.75rem',
                borderRadius: '9999px',
                fontSize: '0.75rem',
                fontWeight: '500',
                background: isCompleted ? '#f0fdf4' : isCurrent ? '#fff7ed' : '#f1f5f9',
                color: isCompleted ? '#166534' : isCurrent ? '#ea580c' : '#64748b',
                border: `1px solid ${isCompleted ? '#bbf7d0' : isCurrent ? '#fed7aa' : '#cbd5e1'}`,
                display: 'flex',
                alignItems: 'center',
                gap: '0.25rem'
              }}>
                {isCompleted && <Check style={{ width: '0.75rem', height: '0.75rem' }} />}
                {isCurrent && <Clock style={{ width: '0.75rem', height: '0.75rem' }} />}
                {ROLES_LABELS[nivel.rol] || nivel.rol}
              </div>
              {index < flujo.length - 1 && (
                <ArrowRight style={{ width: '1rem', height: '1rem', color: '#9ca3af' }} />
              )}
            </React.Fragment>
          );
        })}
      </div>
      
      {/* Historial */}
      {flujo.some(n => n.aprobadoPor) && (
        <div style={{ marginTop: '0.75rem' }}>
          <h6 style={{ fontSize: '0.75rem', fontWeight: '600', color: '#6b7280', margin: 0, marginBottom: '0.5rem' }}>
            HISTORIAL DE APROBACIONES
          </h6>
          {flujo.map((nivel, index) => {
            if (!nivel.aprobadoPor && !nivel.accion) return null;
            
            return (
              <div key={index} style={{ 
                fontSize: '0.75rem', 
                color: '#6b7280', 
                marginBottom: '0.5rem',
                padding: '0.5rem',
                background: nivel.tipo === 'manual' ? '#fef3c7' : 'transparent',
                borderRadius: '0.25rem',
                border: nivel.tipo === 'manual' ? '1px solid #fcd34d' : 'none'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  {nivel.accion?.toLowerCase() === 'aprobada' || nivel.accion?.toLowerCase() === 'auto-aprobado'
                    ? <CheckCircle size={16} style={{ color: '#16a34a', flexShrink: 0 }} />
                    : nivel.accion?.toLowerCase() === 'rechazada'
                      ? <XCircle size={16} style={{ color: '#dc2626', flexShrink: 0 }} />
                      : <Clock size={16} style={{ color: '#d97706', flexShrink: 0 }} />}
                  <strong>{ROLES_LABELS[nivel.rol] || nivel.rol}</strong>
                  {nivel.aprobadoPor && `: ${nivel.aprobadoPor}`}
                  {nivel.tipo === 'manual' && (
                    <span style={{
                      padding: '0.125rem 0.375rem',
                      borderRadius: '9999px',
                      fontSize: '0.625rem',
                      fontWeight: '600',
                      background: '#92400e',
                      color: '#fef3c7'
                    }}>
                      MANUAL
                    </span>
                  )}
                </div>
                <div style={{ marginLeft: '1.25rem', marginTop: '0.25rem' }}>
                 {nivel.fecha ? (
                  <>
                    <span style={{ 
                      fontWeight: '600',
                      color: nivel.accion?.toLowerCase() === 'aprobada' || nivel.accion?.toLowerCase() === 'auto-aprobado'
                        ? '#166534' 
                        : nivel.accion?.toLowerCase() === 'rechazada' 
                        ? '#dc2626' 
                        : '#92400e'
                    }}>
                      {nivel.accion?.toLowerCase() === 'aprobada' || nivel.accion?.toLowerCase() === 'auto-aprobado'
                        ? 'Aprobado' 
                        : nivel.accion?.toLowerCase() === 'rechazada' 
                        ? 'Rechazado' 
                        : nivel.accion}
                    </span>
                    {' — '}{new Date(nivel.fecha).toLocaleString()}
                  </>
                ) : (
                  <em style={{ color: '#9ca3af' }}>Pendiente de aprobación</em>
                )}
                  {nivel.motivoManual && (
                    <div style={{ marginTop: '0.25rem', fontStyle: 'italic' }}>
                      Motivo: {nivel.motivoManual}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};


  return (
    <div style={{ padding: '1.5rem', background: '#f1eeeeff', minHeight: '100vh' }}>
      {/* Modal de Selección de Períodos */}
      {showPeriodosModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: 'white',
            borderRadius: '0.75rem',
            padding: '1.5rem',
            maxWidth: '40rem',
            width: '90%',
            maxHeight: '80vh',
            overflow: 'auto',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
          }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#111827', marginBottom: '1rem' }}>
              Seleccionar Períodos
            </h3>
            
            <div style={{
              background: '#f0f9ff',
              border: '1px solid #bae6fd',
              borderRadius: '0.5rem',
              padding: '1rem',
              marginBottom: '1.5rem'
            }}>
              <p style={{ fontSize: '0.875rem', color: '#0369a1', margin: 0, marginBottom: '0.5rem' }}>
                <strong>Días a solicitar:</strong> {calcularDias()} días
              </p>
              <p style={{ fontSize: '0.875rem', color: '#0369a1', margin: 0 }}>
                <strong>Días seleccionados:</strong> {calcularTotalSeleccionado()} días
              </p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1.5rem' }}>
              {periodosSeleccionados.map((periodo) => (
                <div key={periodo.balanceId} style={{
                  border: '1px solid #e5e7eb',
                  borderRadius: '0.5rem',
                  padding: '1rem',
                  background: '#f9fafb'
                }}>
                  <div style={{ marginBottom: '0.5rem' }}>
                    <strong style={{ fontSize: '0.875rem', color: '#111827' }}>{periodo.descripcion}</strong>
                    <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>
                      Disponibles: {periodo.diasDisponibles} días
                    </p>
                  </div>
                  
                  <div>
                    <label style={{ display: 'block', fontSize: '0.75rem', color: '#374151', marginBottom: '0.25rem' }}>
                      Días a usar de este período:
                    </label>
                    <input
                      type="number"
                      min="0"
                      max={periodo.diasDisponibles}
                      value={periodo.dias}
                      onChange={(e) => actualizarDiasPeriodo(periodo.balanceId, e.target.value)}
                      style={{
                        width: '100%',
                        padding: '0.5rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '0.375rem',
                        fontSize: '0.875rem'
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>

            {calcularTotalSeleccionado() !== calcularDias() && (
              <div style={{
                background: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '0.5rem',
                padding: '0.75rem',
                marginBottom: '1rem'
              }}>
                <p style={{ fontSize: '0.75rem', color: '#dc2626', margin: 0 }}>
                  <AlertTriangle size={14} style={{ verticalAlign:'-2px', marginRight:'0.35rem', flexShrink:0 }} />La suma de días debe ser igual a {calcularDias()} días
                </p>
              </div>
            )}

            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
              <button
  onClick={() => {
    setShowPeriodosModal(false);
    setPeriodosSeleccionados([]);
  }}
  style={{
    padding: '0.5rem 1rem',
    background: '#f3f4f6',
    color: '#374151',
    border: '1px solid #d1d5db',
    borderRadius: '0.375rem',
    fontSize: '0.875rem',
    cursor: 'pointer'
  }}
>
  Cancelar
            </button>

            <button
              onClick={confirmarSolicitudConPeriodos}
              disabled={calcularTotalSeleccionado() !== calcularDias() || loading}
              style={{
                padding: '0.5rem 1rem',
                background: calcularTotalSeleccionado() === calcularDias() && !loading ? '#3b82f6' : '#9ca3af',
                color: 'white',
                border: 'none',
                borderRadius: '0.375rem',
                fontSize: '0.875rem',
                fontWeight: '500',
                cursor: calcularTotalSeleccionado() === calcularDias() && !loading ? 'pointer' : 'not-allowed'
              }}
            >
              {loading ? 'Enviando...' : 'Confirmar Solicitud'}
            </button>
            </div>
          </div>
        </div>
      )}    

       {/* Modal de Rechazo */}
      {mostrarModalRechazo && solicitudSeleccionada && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: 'white',
            borderRadius: '0.5rem',
            padding: '2rem',
            maxWidth: '28rem',
            width: '90%'
          }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>
              Rechazar Solicitud
            </h3>
            <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>
              ¿Estás seguro de rechazar la solicitud de <strong>{solicitudSeleccionada.empleado}</strong>?
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setMostrarModalRechazo(false);
                  setSolicitudSeleccionada(null);
                }}
                style={{
                  padding: '0.5rem 1rem',
                  background: '#f3f4f6',
                  color: '#374151',
                  border: 'none',
                  borderRadius: '0.375rem',
                  cursor: 'pointer'
                }}
              >
                Cancelar
              </button>
              <button
                onClick={async () => {
                  try {
                    setLoading(true);
                    await vacacionesService.procesarSolicitud(solicitudSeleccionada.id, {
                      usuarioID: user.id,
                      accion: 'rechazada',
                      esManual: false,
                      motivoManual: ''
                    });
                    showNotification({
                      title: 'Éxito',
                      message: 'Solicitud rechazada correctamente.',
                      color: 'green',
                    });
                    setMostrarModalRechazo(false);
                    setSolicitudSeleccionada(null);
                    await cargarDatos();
                  } catch (error) {
                    // Notificación de error
                  showNotification({
                    title: 'Error',
                    message: 'Error al rechazar: ' + (error.response?.data?.error || error.message),
                    color: 'red',
                  });
                  } finally {
                    setLoading(false);
                  }
                }}
                disabled={loading}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.5rem 1rem',
                  background: '#ef4444',
                  color: 'white',
                  border: 'none',
                  borderRadius: '0.375rem',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: loading ? 'not-allowed' : 'pointer'
                }}
              >
                <X style={{ width: '1rem', height: '1rem' }} />
                Rechazar
              </button>

            </div>
          </div>
        </div>
      )}

      {/* Modal de Aprobación Manual */}
      {showManualModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: 'white',
            borderRadius: '0.75rem',
            padding: '1.5rem',
            maxWidth: '28rem',
            width: '90%',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
          }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#111827', marginBottom: '1rem' }}>
              Aprobación Manual
            </h3>
            <div style={{
              background: '#fef3c7',
              border: '1px solid #fcd34d',
              borderRadius: '0.5rem',
              padding: '0.75rem',
              marginBottom: '1rem'
            }}>
              <p style={{ fontSize: '0.875rem', color: '#92400e', margin: 0 }}>
                <AlertTriangle size={14} style={{ verticalAlign:'-2px', marginRight:'0.35rem', flexShrink:0 }} />Esta acción saltará el flujo normal de aprobación y será registrada como aprobación manual.
              </p>
            </div>
            
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                Acción
              </label>
              <select
                value={manualApprovalData.accion}
                onChange={(e) => setManualApprovalData(prev => ({ ...prev, accion: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '0.5rem',
                  fontSize: '1rem'
                }}
              >
                <option value="aprobada">Aprobar</option>
                <option value="rechazada">Rechazar</option>
              </select>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                Motivo de la aprobación manual *
              </label>
              <textarea
                value={manualApprovalData.motivo}
                onChange={(e) => setManualApprovalData(prev => ({ ...prev, motivo: e.target.value }))}
                placeholder="Ej: Aprobación urgente por emergencia familiar, autorización directa del CEO, etc."
                rows={3}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '0.5rem',
                  fontSize: '1rem',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowManualModal(false)}
                style={{
                  padding: '0.5rem 1rem',
                  background: '#f3f4f6',
                  color: '#374151',
                  border: '1px solid #d1d5db',
                  borderRadius: '0.375rem',
                  fontSize: '0.875rem',
                  cursor: 'pointer'
                }}
              >
                Cancelar
              </button>
              <button
                onClick={handleManualApproval}
                style={{
                  padding: '0.5rem 1rem',
                  background: '#dc2626',
                  color: 'white',
                  border: 'none',
                  borderRadius: '0.375rem',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Confirmar Aprobación Manual
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={{ maxWidth: '112rem', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#111827', marginBottom: '0.5rem' }}>
          Sistema de Gestión de Autoservicio
        </h1>
        <p style={{ color: '#6b7280', fontSize: '1.125rem', marginBottom: '2rem' }}>
          {getEtiquetaVista()}
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(14rem, 1fr))',
          gap: '1rem',
          marginBottom: '1rem'
        }}>
          <TarjetaIndicador icono={CalendarCheck} color="#059669" etiqueta="Días disponibles de vacaciones" valor={periodos.reduce((sum, p) => sum + p.diasDisponibles, 0)}>
            {periodos.length > 1 && (
              <button
                onClick={() => setActiveTab('periodos')}
                style={{ fontSize: '0.75rem', color: '#2563eb', background: 'none', border: 'none', cursor: 'pointer', padding: 0, fontWeight: '500' }}
              >
                Ver detalle por período
              </button>
            )}
          </TarjetaIndicador>
          <TarjetaIndicador icono={CalendarX} color="#64748b" etiqueta="Días de vacaciones usados" valor={estadisticas.diasUsados || 0} />
          <TarjetaIndicador icono={Clock} color="#d97706" etiqueta="Pendientes en mi nivel" valor={solicitudesPendientes.length} />
          <TarjetaIndicador icono={FileText} color="#2563eb" etiqueta="Total de solicitudes" valor={solicitudes.length}>
            {ROLES_APROBACION_MANUAL.includes(user.rawRole) && (
              <span style={{ fontSize: '0.7rem', fontWeight: '600', color: '#b91c1c', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '9999px', padding: '0.1rem 0.5rem' }}>
                Aprobación manual
              </span>
            )}
          </TarjetaIndicador>
          {misDesignaciones.length > 0 && (
            <TarjetaIndicador icono={Award} color="#7c3aed" etiqueta="Días por designación" valor={diasDesignacion}>
              {misDesignaciones.some(d => d.estado === 'Registrada') && (
                <span style={{ fontSize: '0.72rem', color: '#b45309' }}>Hay días pendientes de habilitar por RRHH</span>
              )}
            </TarjetaIndicador>
          )}
        </div>

        <div style={{
          background: 'white',
          borderRadius: '0.75rem',
          border: '1px solid #e5e7eb',
          boxShadow: '0 1px 2px rgba(15,23,42,0.06)',
          padding: '1rem 1.25rem',
          marginBottom: '2rem',
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem 1.5rem'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <span style={{ width: '2.5rem', height: '2.5rem', borderRadius: '0.625rem', background: '#eef2ff', color: '#4f46e5', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <CalendarDays size={20} />
            </span>
            <span style={{ fontSize: '0.95rem', fontWeight: '600', color: '#0f172a' }}>Permisos del año</span>
          </div>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            {[
              { tipo: 'permiso_personal', label: 'Permiso personal', icono: UserCheck },
              { tipo: 'cumpleanos', label: 'Cumpleaños', icono: Cake }
            ].map(({ tipo, label, icono: Icono }) => {
              const disponibles = permisosDelAnoCargados()
                ? Number(balancePermisos.find(bp => bp.TipoPermiso === tipo)?.DiasDisponibles ?? 0)
                : 0;
              return (
                <span key={tipo} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.35rem 0.75rem', borderRadius: '9999px', background: '#f8fafc', border: '1px solid #e2e8f0', fontSize: '0.8rem', color: '#334155' }}>
                  <Icono size={14} style={{ color: '#64748b' }} />
                  {label}
                  <strong style={{ color: disponibles > 0 ? '#0f172a' : '#94a3b8' }}>{disponibles} {disponibles === 1 ? 'día' : 'días'}</strong>
                </span>
              );
            })}
          </div>
          {!permisosDelAnoCargados() && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flex: '1 1 20rem', padding: '0.5rem 0.75rem', borderRadius: '0.5rem', background: '#eff6ff', color: '#1e3a8a', fontSize: '0.8rem', lineHeight: 1.45 }}>
              <Info size={16} style={{ color: '#2563eb', flexShrink: 0 }} />
              Todos los permisos del año están en cero a nivel del sistema. A partir del 01/01/2027 se cargarán los días correspondientes.
            </div>
          )}
          {MOSTRAR_BALANCE_PERMISOS && (
            <button
              onClick={() => setActiveTab('permisos')}
              style={{ fontSize: '0.75rem', color: '#2563eb', background: 'none', border: 'none', cursor: 'pointer', padding: 0, fontWeight: '500', marginLeft: 'auto' }}
            >
              Ver detalle completo
            </button>
          )}
        </div>

        <div style={{
          background: 'white',
          borderRadius: '0.75rem',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{ display: 'flex', borderBottom: '1px solid #e5e7eb', flexWrap: 'wrap' }}>
            <button
              onClick={() => setActiveTab('solicitar')}
              style={{
                flex: 1,
                minWidth: '150px',
                padding: '1rem',
                border: 'none',
                background: activeTab === 'solicitar' ? '#f8fafc' : 'transparent',
                color: activeTab === 'solicitar' ? '#3b82f6' : '#6b7280',
                fontWeight: activeTab === 'solicitar' ? '600' : '500',
                cursor: 'pointer'
              }}
            >
              Realizar
            </button>
            
            {periodos.length > 1 && (
              <button
                onClick={() => setActiveTab('periodos')}
                style={{
                  flex: 1,
                  minWidth: '150px',
                  padding: '1rem',
                  border: 'none',
                  background: activeTab === 'periodos' ? '#f8fafc' : 'transparent',
                  color: activeTab === 'periodos' ? '#3b82f6' : '#6b7280',
                  fontWeight: activeTab === 'periodos' ? '600' : '500',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem'
                }}
              >
                <Package style={{ width: '1rem', height: '1rem' }} />
                Períodos ({periodos.length})
              </button>
            )}
            {MOSTRAR_BALANCE_PERMISOS && (
            <button
              onClick={() => setActiveTab('permisos')}
              style={{
                flex: 1,
                minWidth: '150px',
                padding: '1rem',
                border: 'none',
                background: activeTab === 'permisos' ? '#f8fafc' : 'transparent',
                color: activeTab === 'permisos' ? '#3b82f6' : '#6b7280',
                fontWeight: activeTab === 'permisos' ? '600' : '500',
                cursor: 'pointer'
              }}
            >
              Mis Permisos
            </button>
            )}
            <button
              onClick={() => setActiveTab('historial')}
              style={{
                flex: 1,
                minWidth: '150px',
                padding: '1rem',
                border: 'none',
                background: activeTab === 'historial' ? '#f8fafc' : 'transparent',
                color: activeTab === 'historial' ? '#3b82f6' : '#6b7280',
                fontWeight: activeTab === 'historial' ? '600' : '500',
                cursor: 'pointer'
              }}
            >
              Historial ({solicitudes.length})
            </button>
            
            {['coordinador', 'gerente', 'director', 'dths_analista', 'dths_coordinador', 'dths_gerente', 'dths_director']
  .includes(user.rawRole?.toLowerCase()) && (
              <button
                onClick={() => setActiveTab('aprobar')}
                style={{
                  flex: 1,
                  minWidth: '150px',
                  padding: '1rem',
                  border: 'none',
                  background: activeTab === 'aprobar' ? '#f8fafc' : 'transparent',
                  color: activeTab === 'aprobar' ? '#3b82f6' : '#6b7280',
                  fontWeight: activeTab === 'aprobar' ? '600' : '500',
                  cursor: 'pointer',
                  position: 'relative'
                }}
              >
                Aprobar Solicitudes
                {solicitudesPendientes.length > 0 && (
                  <span style={{
                    position: 'absolute',
                    top: '0.5rem',
                    right: '0.5rem',
                    background: '#dc2626',
                    color: 'white',
                    borderRadius: '50%',
                    width: '1.5rem',
                    height: '1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.75rem',
                    fontWeight: 'bold'
                  }}>
                    {solicitudesPendientes.length}
                  </span>
                )}
              </button>
            )}
            {ROLES_APROBACION_MANUAL.includes(user.rawRole?.toLowerCase()) && (
              <button
                onClick={() => {
                  setActiveTab('entrada_manual');
                  cargarEmpleados(); // Cargar empleados al abrir la pestaña
                }}
                style={{
                  flex: 1,
                  minWidth: '150px',
                  padding: '1rem',
                  border: 'none',
                  background: activeTab === 'entrada_manual' ? '#f8fafc' : 'transparent',
                  color: activeTab === 'entrada_manual' ? '#3b82f6' : '#6b7280',
                  fontWeight: activeTab === 'entrada_manual' ? '600' : '500',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem'
                }}
              >
                <FileText style={{ width: '1rem', height: '1rem' }} />
                Entrada Manual
              </button>
            )}
            {ROLES_APROBACION_MANUAL.includes(user.rawRole?.toLowerCase()) && (
              <button
                onClick={() => {
                  setActiveTab('designaciones');
                  cargarDesignaciones();
                  if (!empleados.length) cargarEmpleados();
                }}
                style={{
                  flex: 1,
                  minWidth: '150px',
                  padding: '1rem',
                  border: 'none',
                  background: activeTab === 'designaciones' ? '#f8fafc' : 'transparent',
                  color: activeTab === 'designaciones' ? '#3b82f6' : '#6b7280',
                  fontWeight: activeTab === 'designaciones' ? '600' : '500',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem'
                }}
              >
                <Award style={{ width: '1rem', height: '1rem' }} />
                Designaciones
              </button>
            )}
            {ROLES_APROBACION_MANUAL.includes(user.rawRole?.toLowerCase()) && (
              <button
                onClick={() => setActiveTab('feriados')}
                style={{
                  flex: 1,
                  minWidth: '150px',
                  padding: '1rem',
                  border: 'none',
                  background: activeTab === 'feriados' ? '#f8fafc' : 'transparent',
                  color: activeTab === 'feriados' ? '#3b82f6' : '#6b7280',
                  fontWeight: activeTab === 'feriados' ? '600' : '500',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem'
                }}
              >
                <CalendarX style={{ width: '1rem', height: '1rem' }} />
                Días feriados
              </button>
            )}
          </div>

          <div style={{ padding: '2rem' }}>
           {activeTab === 'periodos' && (
                <div>
                  <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#111827', marginBottom: '1.5rem' }}>
                    Períodos de Vacaciones
                  </h3>
                  
                  {/* Tabla de Períodos */}
                  <div style={{
                    border: '1px solid #e5e7eb',
                    borderRadius: '0.5rem',
                    overflow: 'hidden'
                  }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr style={{ background: '#f9fafb' }}>
                          <th style={{
                            padding: '1rem',
                            textAlign: 'left',
                            fontSize: '0.875rem',
                            fontWeight: '600',
                            color: '#374151',
                            borderBottom: '1px solid #e5e7eb'
                          }}>
                            Período
                          </th>
                          <th style={{
                            padding: '1rem',
                            textAlign: 'right',
                            fontSize: '0.875rem',
                            fontWeight: '600',
                            color: '#374151',
                            borderBottom: '1px solid #e5e7eb'
                          }}>
                            Total Acumulado
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {periodos.map((periodo, index) => (
                          <tr key={periodo.balanceId} style={{
                            background: index % 2 === 0 ? 'white' : '#f9fafb'
                          }}>
                            <td style={{
                              padding: '1rem',
                              fontSize: '0.875rem',
                              color: '#111827',
                              borderBottom: '1px solid #e5e7eb'
                            }}>
                              {periodo.anioInicio && periodo.anioFin 
                                ? `${periodo.anioInicio}-${periodo.anioFin}` 
                                : periodo.descripcion}
                            </td>
                            <td style={{
                              padding: '1rem',
                              textAlign: 'right',
                              fontSize: '0.875rem',
                              fontWeight: '500',
                              color: '#111827',
                              borderBottom: '1px solid #e5e7eb'
                            }}>
                              {periodo.diasDisponibles}
                            </td>
                          </tr>
                        ))}
                        {/* Fila de Total */}
                        <tr style={{ background: '#f0f9ff' }}>
                          <td style={{
                            padding: '1rem',
                            fontSize: '0.875rem',
                            fontWeight: '700',
                            color: '#0369a1'
                          }}>
                            Total Acumulado
                          </td>
                          <td style={{
                            padding: '1rem',
                            textAlign: 'right',
                            fontSize: '1rem',
                            fontWeight: '700',
                            color: '#0369a1'
                          }}>
                            {periodos.reduce((sum, p) => sum + p.diasDisponibles, 0)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                        )}

              {activeTab === 'permisos' && (
              <div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#111827', marginBottom: '1.5rem' }}>
                  Balance de Permisos {new Date().getFullYear()}
                </h3>

                {balancePermisos.length === 0 ? (
                  <div style={{
                    textAlign: 'center', padding: '3rem',
                    background: '#f9fafb', borderRadius: '0.5rem', border: '1px solid #e5e7eb'
                  }}>
                    <p style={{ color: '#6b7280' }}>No hay balance de permisos registrado para este año.</p>
                  </div>
                ) : (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(16rem, 1fr))', gap: '1.5rem' }}>
                    {balancePermisos.map(bp => {
                      const config = {
                        permiso_personal: { label: 'Permiso Personal', color: '#3b82f6', bg: '#eff6ff', nota: '3 días anuales, solicitables por el colaborador' },
                        cumpleanos:       { label: 'Cumpleaños',        color: '#f59e0b', bg: '#fffbeb', nota: '1 día, disponible desde tu cumpleaños y durante 30 días' },
                       //*  medico:           { label: 'Permiso Médico',    color: '#10b981', bg: '#f0fdf4', nota: 'Asignado por RRHH' }, 
                        licencia:         { label: 'Licencia',          color: '#8b5cf6', bg: '#faf5ff', nota: 'Asignado por RRHH' },
                      };
                      const c = config[bp.TipoPermiso] || { label: bp.TipoPermiso, color: '#6b7280', bg: '#f9fafb', nota: '' };
                      const pct = bp.DiasTotales > 0 ? Math.round((bp.DiasUsados / bp.DiasTotales) * 100) : 0;

                      return (
                        <div key={bp.BalancePermisoID} style={{
                          background: c.bg,
                          border: `1px solid ${c.color}33`,
                          borderRadius: '0.75rem',
                          padding: '1.5rem'
                        }}>
                          <h4 style={{ fontSize: '1rem', fontWeight: '600', color: '#111827', margin: 0, marginBottom: '1rem' }}>
                            {c.label}
                          </h4>

                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem', marginBottom: '1rem' }}>
                            {[
                              { label: 'Total',     val: bp.DiasTotales,    color: '#374151' },
                              { label: 'Usados',    val: bp.DiasUsados,     color: '#6b7280' },
                              { label: 'Disponibles', val: bp.DiasDisponibles, color: c.color }
                            ].map(item => (
                              <div key={item.label} style={{ textAlign: 'center' }}>
                                <p style={{ fontSize: '0.65rem', color: '#6b7280', margin: 0, fontWeight: '600' }}>
                                  {item.label.toUpperCase()}
                                </p>
                                <p style={{ fontSize: '1.5rem', fontWeight: 'bold', color: item.color, margin: 0 }}>
                                  {item.val}
                                </p>
                              </div>
                            ))}
                          </div>

                          {/* Barra de progreso */}
                          <div style={{ background: '#e5e7eb', borderRadius: '9999px', height: '6px', marginBottom: '0.75rem' }}>
                            <div style={{
                              height: '6px',
                              borderRadius: '9999px',
                              background: c.color,
                              width: `${pct}%`,
                              transition: 'width 0.3s'
                            }} />
                          </div>
                          <p style={{ fontSize: '0.7rem', color: '#6b7280', margin: 0 }}>{c.nota}</p>
                          {bp.DiasPendientes > 0 && (
                            <p style={{ fontSize: '0.7rem', color: '#f59e0b', margin: 0, marginTop: '0.25rem' }}>
                              <Clock size={14} style={{ verticalAlign:'-2px', marginRight:'0.35rem', flexShrink:0 }} />{bp.DiasPendientes} día(s) pendientes de aprobación
                            </p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            {activeTab === 'feriados' && <DiasFeriados alCambiar={cargarFeriados} />}

            {activeTab === 'designaciones' && (() => {
              const campo = { width: '100%', padding: '0.6rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.5rem', fontSize: '0.9rem' };
              const etiqueta = { display: 'block', fontSize: '0.8rem', fontWeight: '500', color: '#374151', marginBottom: '0.35rem' };
              const nombreEmp = (e) => `${e.Nombre || e.NOMBRE || e.nombre || ''} ${e.Apellido || e.APELLIDO || e.apellido || ''}`.trim();
              const idEmp = (e) => e.EmpleadoID || e.EMPLEADOID || e.empleadoId || e.id;
              const idsSeleccionados = new Set(seleccionadosDesignacion.map(s => s.empleadoId));
              const coincidencias = busquedaDesignacion.trim().length >= 2
                ? empleados.filter(e => !idsSeleccionados.has(idEmp(e)) && nombreEmp(e).toLowerCase().includes(busquedaDesignacion.trim().toLowerCase())).slice(0, 8)
                : [];
              const colorEstado = { Registrada: '#b45309', Habilitada: '#15803d', Anulada: '#6b7280' };
              const setF = (k, v) => setDesignacionForm(prev => ({ ...prev, [k]: v }));
              const totalColaboradores = modoDesignacion === 'excel' ? (excelDesignacion?.colaboradores.length || 0) : seleccionadosDesignacion.length;
              const botonModo = (modo, Icono, texto) => (
                <button
                  type="button"
                  onClick={() => setModoDesignacion(modo)}
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.5rem 0.9rem', borderRadius: '0.5rem', fontSize: '0.85rem', cursor: 'pointer',
                    border: modoDesignacion === modo ? '1px solid #7c3aed' : '1px solid #d1d5db',
                    background: modoDesignacion === modo ? '#f5f3ff' : 'white',
                    color: modoDesignacion === modo ? '#6d28d9' : '#374151',
                    fontWeight: modoDesignacion === modo ? '600' : '500'
                  }}
                >
                  <Icono size={16} /> {texto}
                </button>
              );
              return (
                <div>
                  <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#111827', marginBottom: '0.5rem' }}>
                    Días por Designación
                  </h3>
                  <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '1.5rem' }}>
                    Cargue los días que corresponden a colaboradores designados a una feria, misión u otra actividad. El colaborador podrá solicitarlos desde Autoservicio cuando la designación esté habilitada; la solicitud sigue el flujo normal de aprobación.
                  </p>

                  <div style={{ border: '1px solid #e5e7eb', borderRadius: '0.75rem', padding: '1.25rem', marginBottom: '2rem', background: '#fafafa' }}>
                    <h4 style={{ fontSize: '1rem', fontWeight: '600', color: '#111827', margin: '0 0 1rem' }}>Nueva designación</h4>

                    <p style={{ fontSize: '0.8rem', fontWeight: '600', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', margin: '0 0 0.6rem' }}>1. Datos de la feria o misión</p>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(14rem, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
                      <div>
                        <label style={etiqueta}>Tipo *</label>
                        <select value={designacionForm.tipo} onChange={(e) => setF('tipo', e.target.value)} style={campo}>
                          {Object.entries(TIPOS_DESIGNACION).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                        </select>
                      </div>
                      <div>
                        <label style={etiqueta}>Feria / misión / actividad *</label>
                        <input type="text" maxLength={200} value={designacionForm.evento} onChange={(e) => setF('evento', e.target.value)} placeholder="Nombre de la feria o misión" style={campo} />
                      </div>
                      <div>
                        <label style={etiqueta}>Inicio del evento</label>
                        <input type="date" value={designacionForm.fechaEventoInicio} onChange={(e) => setF('fechaEventoInicio', e.target.value)} style={campo} />
                      </div>
                      <div>
                        <label style={etiqueta}>Fin del evento</label>
                        <input type="date" value={designacionForm.fechaEventoFin} min={designacionForm.fechaEventoInicio || undefined} onChange={(e) => setF('fechaEventoFin', e.target.value)} style={campo} />
                      </div>
                      <div>
                        <label style={etiqueta}>Usar a más tardar (opcional)</label>
                        <input type="date" value={designacionForm.fechaVencimiento} min={fechaISOLocal(0)} onChange={(e) => setF('fechaVencimiento', e.target.value)} style={campo} />
                      </div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <label style={etiqueta}>Observaciones</label>
                        <textarea rows={2} maxLength={500} value={designacionForm.observaciones} onChange={(e) => setF('observaciones', e.target.value)} placeholder="Número de oficio, resolución u otra referencia" style={{ ...campo, resize: 'vertical' }} />
                      </div>
                    </div>

                    <p style={{ fontSize: '0.8rem', fontWeight: '600', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', margin: '0 0 0.6rem' }}>2. Colaboradores designados</p>
                    <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
                      {botonModo('seleccion', Users, 'Seleccionar colaboradores')}
                      {botonModo('excel', FileSpreadsheet, 'Cargar desde Excel')}
                    </div>

                    {modoDesignacion === 'seleccion' ? (
                      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(16rem, 2fr) minmax(10rem, 1fr)', gap: '1rem', alignItems: 'start' }}>
                        <div>
                          <div style={{ position: 'relative' }}>
                            <label style={etiqueta}>Buscar y agregar colaboradores</label>
                            <div style={{ position: 'relative' }}>
                              <Search size={16} style={{ position: 'absolute', left: '0.7rem', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af' }} />
                              <input
                                type="text"
                                value={busquedaDesignacion}
                                onChange={(e) => setBusquedaDesignacion(e.target.value)}
                                placeholder={empleados.length ? 'Escriba al menos 2 letras del nombre' : 'Cargando colaboradores...'}
                                style={{ ...campo, paddingLeft: '2.1rem' }}
                              />
                            </div>
                            {coincidencias.length > 0 && (
                              <div style={{ position: 'absolute', zIndex: 20, top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #d1d5db', borderRadius: '0.5rem', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', maxHeight: '16rem', overflowY: 'auto' }}>
                                {coincidencias.map(e => (
                                  <button
                                    key={idEmp(e)}
                                    type="button"
                                    onClick={() => setSeleccionadosDesignacion(prev => [...prev, { empleadoId: idEmp(e), nombre: nombreEmp(e), puesto: e.NombrePuesto || e.CARGO || '' }])}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.5rem', width: '100%', textAlign: 'left', padding: '0.55rem 0.75rem', border: 'none', borderBottom: '1px solid #f3f4f6', background: 'white', cursor: 'pointer', fontSize: '0.85rem' }}
                                  >
                                    <span>
                                      {nombreEmp(e)}
                                      <span style={{ display: 'block', fontSize: '0.72rem', color: '#6b7280' }}>{e.NombrePuesto || e.CARGO || ''}</span>
                                    </span>
                                    <Plus size={16} style={{ color: '#7c3aed', flexShrink: 0 }} />
                                  </button>
                                ))}
                              </div>
                            )}
                          </div>
                          <div style={{ marginTop: '0.75rem', display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                            {seleccionadosDesignacion.length === 0 ? (
                              <span style={{ fontSize: '0.8rem', color: '#9ca3af' }}>Aún no ha agregado colaboradores.</span>
                            ) : seleccionadosDesignacion.map(s => (
                              <span key={s.empleadoId} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem', padding: '0.3rem 0.4rem 0.3rem 0.7rem', borderRadius: '9999px', background: '#f5f3ff', border: '1px solid #ddd6fe', fontSize: '0.8rem', color: '#4c1d95' }}>
                                {s.nombre}
                                <button type="button" aria-label={`Quitar a ${s.nombre}`} onClick={() => setSeleccionadosDesignacion(prev => prev.filter(x => x.empleadoId !== s.empleadoId))} style={{ display: 'flex', border: 'none', background: 'none', cursor: 'pointer', color: '#7c3aed', padding: '0.1rem' }}>
                                  <X size={14} />
                                </button>
                              </span>
                            ))}
                          </div>
                        </div>
                        <div>
                          <label style={etiqueta}>Días a otorgar a cada uno *</label>
                          <input type="number" min="0.5" max="30" step="0.5" value={designacionForm.diasOtorgados} onChange={(e) => setF('diasOtorgados', e.target.value)} style={campo} />
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', alignItems: 'center', padding: '0.9rem 1rem', borderRadius: '0.5rem', background: 'white', border: '1px dashed #c4b5fd' }}>
                          <button type="button" onClick={descargarPlantillaDesignacion} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.5rem 0.9rem', borderRadius: '0.5rem', border: '1px solid #d1d5db', background: 'white', color: '#374151', fontSize: '0.85rem', cursor: 'pointer' }}>
                            <Download size={16} /> Descargar plantilla
                          </button>
                          <label style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.5rem 0.9rem', borderRadius: '0.5rem', background: leyendoExcelDesignacion ? '#9ca3af' : '#7c3aed', color: 'white', fontSize: '0.85rem', cursor: leyendoExcelDesignacion ? 'not-allowed' : 'pointer' }}>
                            <Upload size={16} /> {leyendoExcelDesignacion ? 'Leyendo...' : 'Subir plantilla llena'}
                            <input type="file" accept=".xlsx" disabled={leyendoExcelDesignacion} style={{ display: 'none' }} onChange={(e) => { leerExcelDesignacion(e.target.files?.[0]); e.target.value = ''; }} />
                          </label>
                          <span style={{ fontSize: '0.78rem', color: '#6b7280', flex: '1 1 16rem' }}>
                            La plantilla trae a todos los colaboradores activos. Escriba los días en la columna "Días a otorgar" de quienes participaron y deje vacías las demás filas.
                          </span>
                        </div>
                        {excelDesignacion && (
                          <div style={{ marginTop: '1rem' }}>
                            <p style={{ fontSize: '0.85rem', color: '#374151', margin: '0 0 0.5rem' }}>
                              <strong>{excelDesignacion.archivo}</strong>: {excelDesignacion.colaboradores.length} colaborador(es) con días
                              {excelDesignacion.totalErrores > 0 && <span style={{ color: '#b91c1c' }}>, {excelDesignacion.totalErrores} fila(s) con error que no se cargarán</span>}
                            </p>
                            {excelDesignacion.colaboradores.length > 0 && (
                              <div style={{ maxHeight: '18rem', overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: '0.5rem', background: 'white' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.82rem' }}>
                                  <thead>
                                    <tr style={{ background: '#f9fafb', textAlign: 'left', position: 'sticky', top: 0 }}>
                                      <th style={{ padding: '0.55rem 0.75rem', fontWeight: '600', color: '#374151' }}>Colaborador</th>
                                      <th style={{ padding: '0.55rem 0.75rem', fontWeight: '600', color: '#374151' }}>Departamento</th>
                                      <th style={{ padding: '0.55rem 0.75rem', fontWeight: '600', color: '#374151', textAlign: 'center' }}>Días</th>
                                      <th />
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {excelDesignacion.colaboradores.map(c => (
                                      <tr key={c.empleadoId} style={{ borderTop: '1px solid #f3f4f6' }}>
                                        <td style={{ padding: '0.5rem 0.75rem', color: '#111827' }}>{c.nombre}</td>
                                        <td style={{ padding: '0.5rem 0.75rem', color: '#6b7280' }}>{c.departamento || '—'}</td>
                                        <td style={{ padding: '0.5rem 0.75rem', textAlign: 'center', fontWeight: '600' }}>{c.dias}</td>
                                        <td style={{ padding: '0.5rem 0.75rem', textAlign: 'right' }}>
                                          <button type="button" aria-label={`Quitar a ${c.nombre}`} onClick={() => setExcelDesignacion(prev => ({ ...prev, colaboradores: prev.colaboradores.filter(x => x.empleadoId !== c.empleadoId) }))} style={{ display: 'inline-flex', border: 'none', background: 'none', cursor: 'pointer', color: '#9ca3af' }}>
                                            <X size={16} />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                            {excelDesignacion.errores.length > 0 && (
                              <div style={{ marginTop: '0.75rem', padding: '0.6rem 0.8rem', borderRadius: '0.5rem', background: '#fef2f2', border: '1px solid #fecaca', fontSize: '0.78rem', color: '#991b1b', maxHeight: '8rem', overflowY: 'auto' }}>
                                {excelDesignacion.errores.map((e, i) => <div key={i}>{e}</div>)}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem', marginTop: '1.25rem', paddingTop: '1rem', borderTop: '1px solid #e5e7eb' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.85rem', color: '#374151', cursor: 'pointer' }}>
                        <input type="checkbox" checked={designacionForm.habilitar} onChange={(e) => setF('habilitar', e.target.checked)} />
                        Habilitar de inmediato (los colaboradores podrán solicitarlos ya)
                      </label>
                      <button
                        type="button"
                        onClick={guardarDesignacion}
                        disabled={guardandoDesignacion || totalColaboradores === 0}
                        style={{ background: guardandoDesignacion || totalColaboradores === 0 ? '#9ca3af' : '#7c3aed', color: 'white', padding: '0.6rem 1.25rem', borderRadius: '0.5rem', border: 'none', fontWeight: '500', cursor: guardandoDesignacion || totalColaboradores === 0 ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                      >
                        <Plus size={16} />
                        {guardandoDesignacion ? 'Guardando...' : `Registrar designación${totalColaboradores ? ` (${totalColaboradores} colaborador${totalColaboradores === 1 ? '' : 'es'})` : ''}`}
                      </button>
                    </div>
                  </div>

                  <h4 style={{ fontSize: '1rem', fontWeight: '600', color: '#111827', margin: '0 0 0.75rem' }}>
                    Designaciones registradas ({designaciones.length})
                  </h4>
                  {designaciones.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '2rem', background: '#f9fafb', borderRadius: '0.5rem', border: '1px solid #e5e7eb', color: '#6b7280' }}>
                      No hay designaciones registradas.
                    </div>
                  ) : (
                    <div style={{ overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: '0.5rem' }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
                        <thead>
                          <tr style={{ background: '#f9fafb', textAlign: 'left' }}>
                            {['Colaborador', 'Designación', 'Evento', 'Días (disp. / otorgados)', 'Estado', ''].map(h => (
                              <th key={h} style={{ padding: '0.75rem', fontWeight: '600', color: '#374151', borderBottom: '1px solid #e5e7eb', whiteSpace: 'nowrap' }}>{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {designaciones.map(d => (
                            <tr key={d.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                              <td style={{ padding: '0.75rem', fontWeight: '500', color: '#111827' }}>{d.empleado}</td>
                              <td style={{ padding: '0.75rem' }}>
                                {TIPOS_DESIGNACION[d.tipo] || d.tipo}: {d.evento}
                                {d.observaciones && <span style={{ display: 'block', fontSize: '0.72rem', color: '#6b7280' }}>{d.observaciones}</span>}
                              </td>
                              <td style={{ padding: '0.75rem', whiteSpace: 'nowrap', color: '#4b5563' }}>
                                {d.fechaEventoInicio ? `${formatearFechaISO(d.fechaEventoInicio)}${d.fechaEventoFin ? ` - ${formatearFechaISO(d.fechaEventoFin)}` : ''}` : '—'}
                                {d.fechaVencimiento && <span style={{ display: 'block', fontSize: '0.72rem', color: d.vencida ? '#b91c1c' : '#6b7280' }}>Usar antes del {formatearFechaISO(d.fechaVencimiento)}</span>}
                              </td>
                              <td style={{ padding: '0.75rem', whiteSpace: 'nowrap' }}>
                                <strong>{Number(d.diasDisponibles)}</strong> / {Number(d.diasOtorgados)}
                                {Number(d.diasPendientes) > 0 && <span style={{ display: 'block', fontSize: '0.72rem', color: '#b45309' }}>{Number(d.diasPendientes)} en solicitud pendiente</span>}
                              </td>
                              <td style={{ padding: '0.75rem' }}>
                                <span style={{ color: colorEstado[d.estado] || '#374151', fontWeight: '600' }}>{d.estado}</span>
                                {d.habilitadoPor && d.estado === 'Habilitada' && <span style={{ display: 'block', fontSize: '0.72rem', color: '#6b7280' }}>por {d.habilitadoPor}</span>}
                              </td>
                              <td style={{ padding: '0.75rem', whiteSpace: 'nowrap', textAlign: 'right' }}>
                                {d.estado === 'Registrada' && (
                                  <button type="button" onClick={() => cambiarEstadoDesignacion(d.id, 'habilitar')} style={{ background: '#15803d', color: 'white', border: 'none', borderRadius: '0.375rem', padding: '0.35rem 0.7rem', fontSize: '0.78rem', cursor: 'pointer', marginRight: '0.4rem', display: 'inline-flex', alignItems: 'center', gap: '0.3rem' }}>
                                    <CheckCircle size={14} /> Habilitar
                                  </button>
                                )}
                                {d.estado !== 'Anulada' && Number(d.diasUsados) === 0 && Number(d.diasPendientes) === 0 && (
                                  <button type="button" onClick={() => cambiarEstadoDesignacion(d.id, 'anular')} style={{ background: 'white', color: '#b91c1c', border: '1px solid #fecaca', borderRadius: '0.375rem', padding: '0.35rem 0.7rem', fontSize: '0.78rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.3rem' }}>
                                    <Ban size={14} /> Anular
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              );
            })()}

            {activeTab === 'solicitar' && (
              <div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#111827', marginBottom: '1.5rem' }}>
                  Nueva Solicitud
                </h3>

                <form onSubmit={handleSubmitSolicitud} style={{ maxWidth: '32rem' }}>
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                      Tipo de Solicitud *
                    </label>
                    <select
                      value={solicitudForm.tipo}
                      onChange={(e) => setSolicitudForm(prev => ({ ...prev, tipo: e.target.value, ...(e.target.value === 'cumpleaños' ? { fechaFin: prev.fechaInicio } : {}) }))}
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '0.5rem',
                        fontSize: '1rem'
                      }}
                      required
                    >
                      <option value="vacaciones">Vacaciones</option>
                      <option value="permiso" disabled={!permisosDelAnoCargados()}>
                        Permiso del Año (3 días){!permisosDelAnoCargados() ? ' - disponible desde 01/01/2027' : ''}
                      </option>
                      <option value="cumpleaños" disabled={!permisosDelAnoCargados()}>
                        Permiso de cumpleaños{!permisosDelAnoCargados() ? ' - disponible desde 01/01/2027' : ''}
                      </option>
                      {diasDesignacion > 0 && (
                        <option value="designacion">Días por designación ({diasDesignacion} disponibles)</option>
                      )}
                    </select>
                  </div>

                  {esCumpleanos && (
                    <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start', marginBottom: '1rem', padding: '0.75rem 1rem', borderRadius: '0.5rem', background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e', fontSize: '0.85rem' }}>
                      <Cake size={16} style={{ flexShrink: 0, marginTop: '1px' }} />
                      <span>
                        {!miCumpleanos?.tieneFechaNacimiento
                          ? 'No tienes fecha de nacimiento registrada. Contacta a la DTHyS para poder solicitar tu día de cumpleaños.'
                          : !miCumpleanos.habilitada
                            ? `Tu próximo cumpleaños es el ${formatearFechaISO(miCumpleanos.desde)}. Los días de cumpleaños se habilitan para los cumpleaños desde el 01/01/2027.`
                            : miCumpleanos.disponibles < 1
                              ? `Ya usaste o tienes en trámite tu día de cumpleaños (plazo del ${formatearFechaISO(miCumpleanos.desde)} al ${formatearFechaISO(miCumpleanos.hasta)}).`
                              : `Tienes 1 día por tu cumpleaños. Puedes tomarlo un día laborable entre el ${formatearFechaISO(miCumpleanos.desde)} y el ${formatearFechaISO(miCumpleanos.hasta)} (30 días desde tu cumpleaños).`}
                      </span>
                    </div>
                  )}

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
                    <div>
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                        Fecha de Inicio *
                      </label>
                      <input
                        type="date"
                        value={solicitudForm.fechaInicio}
                        onChange={(e) => setSolicitudForm(prev => ({ ...prev, fechaInicio: e.target.value, ...(prev.tipo === 'cumpleaños' ? { fechaFin: e.target.value } : {}) }))}
                        min={esCumpleanos && miCumpleanos?.desde > fechaISOLocal(1) ? miCumpleanos.desde : fechaISOLocal(1)}
                        max={esCumpleanos && miCumpleanos?.habilitada ? miCumpleanos.hasta : undefined}
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          border: '1px solid #d1d5db',
                          borderRadius: '0.5rem',
                          fontSize: '1rem'
                        }}
                        required
                      />
                    </div>

                    <div>
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                        Fecha de Fin *
                      </label>
                      <input
                        type="date"
                        value={solicitudForm.fechaFin}
                        onChange={(e) => setSolicitudForm(prev => ({ ...prev, fechaFin: e.target.value }))}
                        min={solicitudForm.fechaInicio || fechaISOLocal(1)}
                        disabled={esCumpleanos}
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          border: '1px solid #d1d5db',
                          borderRadius: '0.5rem',
                          fontSize: '1rem'
                        }}
                        required
                      />
                    </div>
                  </div>

                  {calcularDias() > 0 && (
                    <div style={{
                      background: '#f0f9ff',
                      border: '1px solid #bae6fd',
                      borderRadius: '0.5rem',
                      padding: '1rem',
                      marginBottom: '1.5rem'
                    }}>
                     
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                      <div>
                        <p style={{ fontSize: '0.75rem', color: '#0369a1', margin: 0, marginBottom: '0.25rem', fontWeight: '600' }}>
                          DÍAS A SOLICITAR
                        </p>
                        <p style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#0369a1', margin: 0 }}>
                          {calcularDiasHabiles()}
                        </p>
                      </div>
                      {['vacaciones', 'permiso', 'cumpleaños', 'designacion'].includes(solicitudForm.tipo) && (() => {
                        let dispLabel = diasDisponibles;
                        if (solicitudForm.tipo === 'designacion') dispLabel = diasDesignacion;
                        if (solicitudForm.tipo === 'permiso') {
                          dispLabel = balancePermisos.find(bp => bp.TipoPermiso === 'permiso_personal')?.DiasDisponibles ?? 0;
                        } else if (solicitudForm.tipo === 'cumpleaños') {
                          dispLabel = miCumpleanos?.habilitada ? miCumpleanos.disponibles : (balancePermisos.find(bp => bp.TipoPermiso === 'cumpleanos')?.DiasDisponibles ?? 0);
                        }
                        return (
                          <div>
                            <p style={{ fontSize: '0.75rem', color: '#0369a1', margin: 0, marginBottom: '0.25rem', fontWeight: '600' }}>
                              DÍAS DISPONIBLES
                            </p>
                            <p style={{ 
                              fontSize: '1.5rem', 
                              fontWeight: 'bold', 
                              color: dispLabel >= calcularDiasHabiles() ? '#0369a1' : '#dc2626', 
                              margin: 0 
                            }}>
                              {dispLabel}
                            </p>
                          </div>
                        );
                      })()}
                    </div>
                      
                      {feriadosEnRango().length > 0 && (
                        <p style={{ fontSize: '0.75rem', color: '#0369a1', margin: '0.75rem 0 0', display: 'flex', gap: '0.35rem', alignItems: 'flex-start' }}>
                          <CalendarX size={14} style={{ flexShrink: 0, marginTop: '1px' }} />
                          <span>No se cuentan los feriados: {feriadosEnRango().map(f => `${formatearFechaISO(f.fecha)} (${f.descripcion})`).join(', ')}.</span>
                        </p>
                      )}

                      {solicitudForm.tipo === 'vacaciones' && calcularDias() > estadisticas.diasDisponibles && (
                        <div style={{ marginTop: '0.75rem', padding: '0.5rem', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '0.375rem' }}>
                          <p style={{ fontSize: '0.75rem', color: '#dc2626', margin: 0 }}>
                            <AlertTriangle size={14} style={{ verticalAlign:'-2px', marginRight:'0.35rem', flexShrink:0 }} />No tienes suficientes días de vacaciones disponibles
                          </p>
                        </div>
                      )}
                      
                      {solicitudForm.tipo === 'vacaciones' && periodos.length > 1 && calcularDias() <= estadisticas.diasDisponibles && (
                        <div style={{ marginTop: '0.75rem', padding: '0.5rem', background: '#fef3c7', border: '1px solid #fcd34d', borderRadius: '0.375rem' }}>
                          <p style={{ fontSize: '0.75rem', color: '#92400e', margin: 0 }}>
                            <Info size={14} style={{ verticalAlign:'-2px', marginRight:'0.35rem', flexShrink:0 }} />Tienes {periodos.length} períodos disponibles. Podrás seleccionar de cuál período usar días.
                          </p>
                        </div>
                      )}
                    </div>
                  )}

                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                      Motivo / Justificación *
                    </label>
                    <textarea
                      value={solicitudForm.motivo}
                      onChange={(e) => setSolicitudForm(prev => ({ ...prev, motivo: e.target.value }))}
                      placeholder="Describe el motivo de tu solicitud..."
                      rows={4}
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '0.5rem',
                        fontSize: '1rem',
                        resize: 'vertical'
                      }}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      background: loading ? '#9ca3af' : '#3b82f6',
                      color: 'white',
                      padding: '0.75rem 1.5rem',
                      borderRadius: '0.5rem',
                      border: 'none',
                      fontSize: '1rem',
                      fontWeight: '500',
                      cursor: loading ? 'not-allowed' : 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}
                  >
                    <Plus style={{ width: '1rem', height: '1rem' }} />
                    {loading ? 'Enviando...' : 'Enviar Solicitud'}
                  </button>
                </form>
              </div>
            )}

            {activeTab === 'historial' && (
              <div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#111827', marginBottom: '1rem' }}>
                  Historial de Solicitudes
                </h3>

                {loading ? (
                  <div style={{ textAlign: 'center', padding: '3rem' }}>
                    <p>Cargando...</p>
                  </div>
                ) : solicitudes.length === 0 ? (
                  <div style={{
                    textAlign: 'center',
                    padding: '3rem',
                    background: '#f9fafb',
                    borderRadius: '0.5rem',
                    border: '1px solid #e5e7eb'
                  }}>
                    <FileText style={{ width: '3rem', height: '3rem', color: '#9ca3af', margin: '0 auto 1rem' }} />
                    <h4 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', margin: 0, marginBottom: '0.5rem' }}>
                      No hay solicitudes
                    </h4>
                    <p style={{ color: '#6b7280', margin: 0 }}>
                      Aún no tienes solicitudes de vacaciones registradas.
                    </p>
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {solicitudes.map(solicitud => {
                      const estadoStyle = getEstadoColor(solicitud.estado);
                      const esMia = solicitud.empleadoId === user.empleadoId;
                      const permisoAprobacion = puedeAprobar(solicitud);
                      
                      return (
                        <div
                          key={solicitud.id}
                          style={{
                            border: esMia ? '2px solid #3b82f6' : '1px solid #e5e7eb',
                            borderRadius: '0.5rem',
                            padding: '1.5rem',
                            background: esMia ? '#f8fafc' : 'white'
                          }}
                        >
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '1rem' }}>
                            <div>
                              <h4 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', margin: 0, marginBottom: '0.5rem' }}>
                                {solicitud.empleado} - {getTipoLabel(solicitud.tipo)}
                                {esMia && (
                                  <span style={{
                                    marginLeft: '0.5rem',
                                    padding: '0.125rem 0.5rem',
                                    borderRadius: '9999px',
                                    fontSize: '0.75rem',
                                    fontWeight: '500',
                                    background: '#dbeafe',
                                    color: '#1d4ed8'
                                  }}>
                                    MÍA
                                  </span>
                                )}
                              </h4>
                              <p style={{ fontSize: '0.875rem', color: '#6b7280', margin: 0 }}>
                                {solicitud.puesto} • {solicitud.departamento}
                              </p>
                            </div>
                            <span style={{
                              padding: '0.25rem 0.75rem',
                              borderRadius: '9999px',
                              fontSize: '0.75rem',
                              fontWeight: '500',
                              background: estadoStyle.bg,
                              color: estadoStyle.color,
                              border: `1px solid ${estadoStyle.border}`,
                              textTransform: 'capitalize'
                            }}>
                              {solicitud.estado === 'pendiente' && <Clock style={{ width: '0.75rem', height: '0.75rem', display: 'inline', marginRight: '0.25rem' }} />}
                              {solicitud.estado === 'aprobada' && <Check style={{ width: '0.75rem', height: '0.75rem', display: 'inline', marginRight: '0.25rem' }} />}
                              {solicitud.estado === 'rechazada' && <X style={{ width: '0.75rem', height: '0.75rem', display: 'inline', marginRight: '0.25rem' }} />}
                              {solicitud.estado}
                            </span>
                          </div>

                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(10rem, 1fr))', gap: '1rem', marginBottom: '1rem' }}>
                            <div>
                              <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>FECHA INICIO</p>
                              <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#111827', margin: 0 }}>
                                {new Date(solicitud.fechaInicio).toLocaleDateString()}
                              </p>
                            </div>
                            <div>
                              <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>FECHA FIN</p>
                              <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#111827', margin: 0 }}>
                                {new Date(solicitud.fechaFin).toLocaleDateString()}
                              </p>
                            </div>
                            <div>
                              <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>DÍAS</p>
                              <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#111827', margin: 0 }}>
                                {solicitud.dias} días
                              </p>
                            </div>
                          </div>

                          <div style={{ marginBottom: '1rem' }}>
                            <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>MOTIVO</p>
                            <p style={{ fontSize: '0.875rem', color: '#111827', margin: 0 }}>
                              {solicitud.motivo}
                            </p>
                          </div>

                          <FlujAprobacion 
                            flujo={solicitud.flujoAprobacion} 
                            estado={solicitud.estado}
                            aprobacionManual={solicitud.aprobacionManual}
                          />

                          {/* BOTONES DE APROBACIÓN */}
                            {permisoAprobacion.puede && solicitud.estado === 'pendiente' && (
                              <div style={{ 
                                marginTop: '1rem', 
                                paddingTop: '1rem', 
                                borderTop: '1px solid #e5e7eb',
                                display: 'flex',
                                gap: '0.75rem',
                                alignItems: 'center'
                              }}>
                                {permisoAprobacion.motivo === 'manual' && (
                                  <div style={{
                                    flex: 1,
                                    padding: '0.75rem',
                                    background: '#fef3c7',
                                    border: '1px solid #fcd34d',
                                    borderRadius: '0.375rem',
                                    fontSize: '0.75rem',
                                    color: '#92400e',
                                    fontWeight: '500'
                                  }}>
                                    <AlertTriangle size={14} style={{ verticalAlign:'-2px', marginRight:'0.35rem', flexShrink:0 }} />Aprobación manual - Debes proporcionar un motivo
                                  </div>
                                )}
                                
                                {permisoAprobacion.motivo === 'normal' ? (
                                  <>
                                   <button
                                      onClick={async () => {
                                        try {
                                          setLoading(true);
                                          await vacacionesService.procesarSolicitud(solicitud.id, {
                                            usuarioID: user.id,
                                            accion: 'aprobada',
                                            esManual: false,
                                            motivoManual: ''
                                          });
                                          showNotification({
                                            title: 'Éxito',
                                            message: 'Solicitud aprobada correctamente.',
                                            color: 'green',
                                          });
                                          await cargarDatos();
                                        } catch (error) {
                                          showNotification({
                                            title: 'Error',
                                            message: 'Error al aprobar: ' + (error.response?.data?.error || error.message),
                                            color: 'red',
                                          });
                                        } finally {
                                          setLoading(false);
                                        }
                                      }}
                                      disabled={loading}
                                      style={{
                                        padding: '0.625rem 1.25rem',
                                        background: loading ? '#9ca3af' : '#10b981',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '0.375rem',
                                        fontSize: '0.875rem',
                                        fontWeight: '500',
                                        cursor: loading ? 'not-allowed' : 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.375rem',
                                        transition: 'all 0.2s'
                                      }}
                                      onMouseOver={(e) => !loading && (e.target.style.background = '#059669')}
                                      onMouseOut={(e) => !loading && (e.target.style.background = '#10b981')}
                                    >
                                      <Check style={{ width: '1rem', height: '1rem' }} />
                                      Aprobar
                                    </button>

                                    
                                    <button
                                        onClick={async () => {
                                          try {
                                            setLoading(true);
                                            await vacacionesService.procesarSolicitud(solicitud.id, {
                                              usuarioID: user.id,
                                              accion: 'rechazada',
                                              esManual: false,
                                              motivoManual: ''
                                            });
                                           // Notificación de éxito
                                              showNotification({
                                                title: 'Éxito',
                                                message: 'Solicitud rechazada correctamente.',
                                                color: 'green',
                                              });
                                          await cargarDatos();
                                          } catch (error) {
                                            // Notificación de error
                                            showNotification({
                                              title: 'Error',
                                              message: 'Error al rechazar: ' + (error.response?.data?.error || error.message),
                                              color: 'red',
                                            });
                                          } finally {
                                            setLoading(false);
                                          }
                                        }}
                                        disabled={loading}
                                        style={{
                                          padding: '0.625rem 1.25rem',
                                          background: loading ? '#9ca3af' : '#ef4444',
                                          color: 'white',
                                          border: 'none',
                                          borderRadius: '0.375rem',
                                          fontSize: '0.875rem',
                                          fontWeight: '500',
                                          cursor: loading ? 'not-allowed' : 'pointer',
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '0.375rem',
                                          transition: 'all 0.2s'
                                        }}
                                        onMouseOver={(e) => !loading && (e.target.style.background = '#dc2626')}
                                        onMouseOut={(e) => !loading && (e.target.style.background = '#ef4444')}
                                      >
                                        <X style={{ width: '1rem', height: '1rem' }} />
                                        Rechazar
                                      </button>

                                  </>
                                ) : (
                                  <button
                                    onClick={() => openManualModal(solicitud.id, 'aprobada')}
                                    disabled={loading}
                                    style={{
                                      padding: '0.625rem 1.25rem',
                                      background: loading ? '#9ca3af' : '#dc2626',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '0.375rem',
                                      fontSize: '0.875rem',
                                      fontWeight: '500',
                                      cursor: loading ? 'not-allowed' : 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '0.375rem'
                                    }}
                                  >
                                    <Edit style={{ width: '1rem', height: '1rem' }} />
                                    Aprobación Manual
                                  </button>
                                )}
                              </div>
                            )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            {activeTab === 'aprobar' && (
              <div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#111827', marginBottom: '1rem' }}>
                  Solicitudes Pendientes ({solicitudesPendientes.length})
                </h3>
                {ROLES_APROBACION_MANUAL.includes(user.rawRole?.toLowerCase()) && (
                  <div style={{ border: '1px solid #bfdbfe', background: '#eff6ff', borderRadius: '0.5rem', padding: '1rem', marginBottom: '1.5rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.75rem' }}>
                      <div>
                        <p style={{ margin: 0, fontWeight: '600', color: '#1e3a8a', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                          <Mail size={16} /> Recordatorio a líderes
                        </p>
                        <p style={{ margin: '0.25rem 0 0', fontSize: '0.8rem', color: '#1e40af' }}>
                          Sale automáticamente de lunes a viernes a las 8:00 a. m. a cada líder de área (coordinador, gerente y director) con las solicitudes pendientes en su nivel.
                        </p>
                      </div>
                      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', alignItems: 'center' }}>
                        <button type="button" onClick={verRecordatorios} style={{ background: 'white', color: '#1d4ed8', border: '1px solid #93c5fd', borderRadius: '0.375rem', padding: '0.45rem 0.8rem', fontSize: '0.8rem', cursor: 'pointer' }}>
                          Ver quién lo recibe
                        </button>
                        <input
                          type="email"
                          value={correoPruebaRecordatorio}
                          onChange={(e) => setCorreoPruebaRecordatorio(e.target.value)}
                          placeholder="Correo de prueba (opcional)"
                          style={{ padding: '0.45rem 0.6rem', border: '1px solid #93c5fd', borderRadius: '0.375rem', fontSize: '0.8rem', minWidth: '14rem' }}
                        />
                        <button type="button" onClick={enviarRecordatoriosAhora} disabled={enviandoRecordatorio} style={{ background: enviandoRecordatorio ? '#9ca3af' : '#1d4ed8', color: 'white', border: 'none', borderRadius: '0.375rem', padding: '0.45rem 0.8rem', fontSize: '0.8rem', cursor: enviandoRecordatorio ? 'not-allowed' : 'pointer' }}>
                          {enviandoRecordatorio ? 'Enviando...' : correoPruebaRecordatorio.trim() ? 'Enviar prueba' : 'Enviar ahora'}
                        </button>
                      </div>
                    </div>
                    {recordatorios && (
                      <div style={{ marginTop: '0.75rem', background: 'white', border: '1px solid #dbeafe', borderRadius: '0.375rem', padding: '0.75rem', fontSize: '0.8rem', color: '#374151' }}>
                        {recordatorios.destinatarios.length === 0 ? (
                          <p style={{ margin: 0 }}>No hay solicitudes pendientes: hoy no se enviaría ningún recordatorio.</p>
                        ) : (
                          <ul style={{ margin: 0, paddingLeft: '1.1rem' }}>
                            {recordatorios.destinatarios.map(d => (
                              <li key={d.usuarioId} style={{ marginBottom: '0.25rem' }}>
                                <strong>{d.nombre}</strong> ({ROLES_LABELS[d.rol] || d.rol}) — {d.solicitudes.length} solicitud(es)
                                {d.email ? ` — ${d.email}` : <span style={{ color: '#b91c1c' }}> — sin correo registrado</span>}
                              </li>
                            ))}
                          </ul>
                        )}
                        {recordatorios.sinAprobador.length > 0 && (
                          <p style={{ margin: '0.5rem 0 0', color: '#b45309' }}>
                            {recordatorios.sinAprobador.length} solicitud(es) no tienen un líder de área en su cadena de supervisores (nadie las ve en su bandeja; revise el supervisor inmediato): {recordatorios.sinAprobador.map(s => s.empleado).join(', ')}.
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                )}

                
                {ROLES_APROBACION_MANUAL.includes(user.rawRole) && (
                  <div style={{
                    background: '#fef3c7',
                    border: '1px solid #fcd34d',
                    borderRadius: '0.5rem',
                    padding: '1rem',
                    marginBottom: '1.5rem'
                  }}>
                    <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#92400e', margin: 0, marginBottom: '0.5rem' }}>
                      <KeyRound size={14} style={{ verticalAlign:'-2px', marginRight:'0.35rem', flexShrink:0 }} />Privilegios de Aprobación Manual
                    </h4>
                    <p style={{ fontSize: '0.75rem', color: '#92400e', margin: 0 }}>
                      Puedes realizar aprobaciones manuales que saltan el flujo normal.
                    </p>
                  </div>
                )}

                {solicitudesPendientes.length === 0 ? (
                  <div style={{
                    textAlign: 'center',
                    padding: '3rem',
                    background: '#f9fafb',
                    borderRadius: '0.5rem',
                    border: '1px solid #e5e7eb'
                  }}>
                    <Users style={{ width: '3rem', height: '3rem', color: '#9ca3af', margin: '0 auto 1rem' }} />
                    <h4 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', margin: 0 }}>
                      No hay solicitudes pendientes
                    </h4>
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {solicitudesPendientes.map(solicitud => {
                      const permisos = puedeAprobar(solicitud);
                      const esNormal = permisos.motivo === 'normal';
                      const soloManual = esRRHH && !esNormal;
                                            
                      return (
                        <div key={solicitud.id} style={{
                          border: '1px solid #e5e7eb',
                          borderRadius: '0.5rem',
                          padding: '1.5rem',
                          background: esNormal ? '#fffbeb' : soloManual ? '#fafafa' : '#fef3c7'
                        }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                            <div>
                              <h4 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', margin: 0 }}>
                                {solicitud.empleado} - {getTipoLabel(solicitud.tipo)}
                              </h4>
                              <p style={{ fontSize: '0.875rem', color: '#6b7280', margin: 0 }}>
                                {solicitud.dias} días • {new Date(solicitud.fechaInicio).toLocaleDateString()} - {new Date(solicitud.fechaFin).toLocaleDateString()}
                              </p>
                            </div>
                          </div>

                          <div style={{ marginBottom: '1rem' }}>
                            <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>MOTIVO</p>
                            <p style={{ fontSize: '0.875rem', color: '#111827', margin: 0 }}>{solicitud.motivo}</p>
                          </div>

                          <FlujAprobacion flujo={solicitud.flujoAprobacion} estado={solicitud.estado} />
                          {soloManual && (
                              <div style={{
                                padding: '0.5rem 0.75rem',
                                background: '#f1f5f9',
                                border: '1px solid #cbd5e1',
                                borderRadius: '0.375rem',
                                fontSize: '0.75rem',
                                color: '#475569',
                                marginBottom: '0.75rem'
                              }}>
                                <Info size={14} style={{ verticalAlign:'-2px', marginRight:'0.35rem', flexShrink:0 }} />Solicitud en proceso — puedes intervenir con aprobación manual si es necesario
                              </div>
                            )}

                          <div style={{ marginTop: '1.5rem', display: 'flex', gap: '0.75rem' }}>
                            {esNormal ? (
                              <>
                                <button
                                    onClick={async () => {
                                      try {
                                        setLoading(true);
                                        await vacacionesService.procesarSolicitud(solicitud.id, {
                                          usuarioID: user.id,
                                          accion: 'aprobada',
                                          esManual: false,
                                          motivoManual: ''
                                        });

                                        // ✅ Notificación moderna
                                        showNotification({
                                          title: 'Éxito',
                                          message: 'Solicitud aprobada correctamente',
                                          color: 'green', // 'green' para éxito, 'red' para error, 'yellow' para advertencia
                                        });

                                        await cargarDatos();
                                      } catch (error) {
                                        showNotification({
                                          title: 'Error',
                                          message: 'Error al aprobar: ' + (error.response?.data?.error || error.message),
                                          color: 'red', // 'red' para errores
                                        });

                                      } finally {
                                        setLoading(false);
                                      }
                                    }}
                                    disabled={loading}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '0.5rem',
                                      padding: '0.5rem 1rem',
                                      background: loading ? '#9ca3af' : '#10b981',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '0.375rem',
                                      fontSize: '0.875rem',
                                      fontWeight: '500',
                                      cursor: loading ? 'not-allowed' : 'pointer'
                                    }}
                                  >
                                    <Check style={{ width: '1rem', height: '1rem' }} />
                                    Aprobar
                                  </button>

                                <button
                                    onClick={async () => {
                                      try {
                                        setLoading(true);
                                        await vacacionesService.procesarSolicitud(solicitud.id, {
                                          usuarioID: user.id,
                                          accion: 'rechazada',
                                          esManual: false,
                                          motivoManual: ''
                                        });

                                        // ✅ Notificación unificada
                                        showNotification({
                                          title: 'Éxito',
                                          message: 'Solicitud rechazada correctamente',
                                          color: 'green', // 'green' indica éxito
                                        });


                                        await cargarDatos();
                                      } catch (error) {
                                        showNotification({
                                          title: 'Error',
                                          message: 'Error al rechazar: ' + (error.response?.data?.error || error.message),
                                          color: 'red',
                                        });

                                      } finally {
                                        setLoading(false);
                                      }
                                    }}
                                    disabled={loading}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '0.5rem',
                                      padding: '0.5rem 1rem',
                                      background: loading ? '#9ca3af' : '#ef4444',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '0.375rem',
                                      fontSize: '0.875rem',
                                      fontWeight: '500',
                                      cursor: loading ? 'not-allowed' : 'pointer'
                                    }}
                                  >
                                    <X style={{ width: '1rem', height: '1rem' }} />
                                    Rechazar
                                  </button>

                              </>
                            ) : (
                              <>
                                <button
                                  onClick={() => openManualModal(solicitud.id, 'aprobada')}
                                  disabled={loading}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    padding: '0.5rem 1rem',
                                    background: loading ? '#9ca3af' : '#dc2626',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '0.375rem',
                                    fontSize: '0.875rem',
                                    fontWeight: '500',
                                    cursor: loading ? 'not-allowed' : 'pointer'
                                  }}
                                >
                                  <Edit style={{ width: '1rem', height: '1rem' }} />
                                  Aprobación Manual
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
            {activeTab === 'entrada_manual' && (
              <div>
                {/* Alerta informativa */}
                <div style={{
                  background: '#fef3c7',
                  border: '1px solid #fcd34d',
                  borderRadius: '0.5rem',
                  padding: '1rem',
                  marginBottom: '2rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem'
                }}>
                  <AlertTriangle style={{ width: '1.25rem', height: '1.25rem', color: '#92400e' }} />
                  <div>
                    <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#92400e', margin: 0, marginBottom: '0.25rem' }}>
                      Entrada Manual de Solicitudes Ejecutadas
                    </h4>
                    <p style={{ fontSize: '0.75rem', color: '#92400e', margin: 0 }}>
                      Registra solicitudes que YA fueron ejecutadas para descontar los días del balance.
                    </p>
                  </div>
                </div>

                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#111827', marginBottom: '1.5rem' }}>
                  Registrar Solicitud Ejecutada
                </h3>

                

                <form onSubmit={async (e) => {
                  e.preventDefault();
                  
                  if (!entradaManualForm.empleadoId) {
                    showNotification({
                      title: 'Error',
                      message: 'Debes seleccionar un empleado',
                      color: 'red'
                    });
                    return;
                  }

                  const inicio = parseFechaLocal(entradaManualForm.fechaInicio);
                  const fin = parseFechaLocal(entradaManualForm.fechaFin);
                  
                  if (fin < inicio) {
                    showNotification({
                      title: 'Error',
                      message: 'La fecha de fin debe ser posterior a la fecha de inicio',
                      color: 'red'
                    });
                    return;
                  }

                  // Se descuentan días laborables: sin fines de semana ni feriados
                  const diasHabiles = contarLaborables(entradaManualForm.fechaInicio, entradaManualForm.fechaFin);
                  const dias = diasHabiles;
                  if (dias <= 0) {
                    showNotification({ title: 'Error', message: 'Las fechas elegidas no tienen días laborables (fines de semana o feriados).', color: 'red' });
                    return;
                  }

                  try {
                    setLoading(true);
                    
                    await vacacionesService.crearSolicitudManual({
                      empleadoID: entradaManualForm.empleadoId,
                      tipo: entradaManualForm.tipoSolicitud,
                      fechaInicio: entradaManualForm.fechaInicio,
                      fechaFin: entradaManualForm.fechaFin,
                      dias: dias,
                      diasHabiles: diasHabiles,
                      motivo: `[ENTRADA MANUAL - DTHS] ${entradaManualForm.justificacion}${entradaManualForm.documentoReferencia ? ` | Ref: ${entradaManualForm.documentoReferencia}` : ''}`
                    });

                    showNotification({
                      title: 'Éxito',
                      message: `Solicitud registrada y ${dias} días descontados del balance de ${entradaManualForm.empleadoNombre}`,
                      color: 'green'
                    });

                    setEntradaManualForm({
                      empleadoId: null,
                      empleadoNombre: '',
                      tipoSolicitud: 'vacaciones',
                      fechaInicio: '',
                      fechaFin: '',
                      justificacion: '',
                      documentoReferencia: ''
                    });
                    setEmpleadoBusqueda('');

                    await cargarDatos();
                  } catch (error) {
                    showNotification({
                      title: 'Error',
                      message: 'Error al registrar: ' + (error.response?.data?.error || error.message),
                      color: 'red'
                    });
                  } finally {
                    setLoading(false);
                  }
                }} style={{ maxWidth: '48rem' }}>
                  
                  {/* Selector de Empleado */}
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                      Empleado *
                    </label>
                    <div style={{ position: 'relative' }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '0.5rem',
                        background: 'white'
                      }}>
                        <Users style={{ width: '1.25rem', height: '1.25rem', color: '#6b7280' }} />
                        <input
                          type="text"
                          value={entradaManualForm.empleadoNombre || empleadoBusqueda}
                          onChange={(e) => {
                            setEmpleadoBusqueda(e.target.value);
                            setMostrarListaEmpleados(true);
                            setEntradaManualForm(prev => ({ ...prev, empleadoId: null, empleadoNombre: '' }));
                          }}
                          onFocus={() => {
                          setMostrarListaEmpleados(true);
                          console.log('🔵 Input focused, empleados:', empleados.length);
                        }}
                        placeholder="Buscar empleado..."
                        style={{
                          flex: 1,
                          border: 'none',
                          outline: 'none',
                          fontSize: '1rem'
                        }}
                        required
                        />
                      </div>

                      {mostrarListaEmpleados && (
                        <div style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          right: 0,
                          marginTop: '0.25rem',
                          background: 'white',
                          border: '1px solid #d1d5db',
                          borderRadius: '0.5rem',
                          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                          maxHeight: '16rem',
                          overflow: 'auto',
                          zIndex: 10
                        }}>
                          {(() => {
                        // ✅ LOGS DE DEBUG
                        console.log('🔍 RENDERIZANDO LISTA DE EMPLEADOS:', {
                          total: empleados.length,
                          primerEmpleado: empleados[0],
                          propiedades: empleados[0] ? Object.keys(empleados[0]) : []
                        });
                        
                        // Filtrar empleados (si no hay búsqueda, mostrar todos)
                        const filtrados = empleadoBusqueda 
                          ? empleados.filter(emp => {
                              const nombre = emp.NOMBRE || emp.Nombre || emp.nombre || '';
                              const apellido = emp.APELLIDO || emp.Apellido || emp.apellido || '';
                              const nombreCompleto = `${nombre} ${apellido}`.toLowerCase();
                              return nombreCompleto.includes(empleadoBusqueda.toLowerCase());
                            })
                          : empleados;
                        
                        // Si no hay resultados después del filtro
                        if (filtrados.length === 0) {
                          return (
                            <div style={{ padding: '1rem', textAlign: 'center', color: '#6b7280' }}>
                              {empleadoBusqueda 
                                ? `No se encontraron empleados con "${empleadoBusqueda}"`
                                : 'No hay empleados disponibles'}
                            </div>
                          );
                        }
                        
                        // Mostrar empleados filtrados
                        return filtrados.map((empleado, index) => {
  // ✅ Normalizar nombres (SQL Server devuelve en MAYÚSCULAS)
  const nombre = empleado.Nombre || empleado.NOMBRE || empleado.nombre || '';
  const apellido = empleado.Apellido || empleado.APELLIDO || empleado.apellido || '';
  const puesto = empleado.NombrePuesto || empleado.CARGO || empleado.Puesto || empleado.puesto || '';
  const departamento = empleado.DEPARTAMENTO_NOMBRE || empleado.Departamento || empleado.DEPARTAMENTO || '';
  const id = empleado.EmpleadoID || empleado.EMPLEADOID || empleado.empleadoId || empleado.id;
  
  // ✅ LOG DEL PRIMER EMPLEADO
  if (index === 0) {
    console.log('👤 PRIMER EMPLEADO PROCESADO:', {
      id, nombre, apellido, puesto, departamento,
      objetoOriginal: empleado
    });
  }
  
  return (
    <button
      key={id || index}
      type="button"
      onClick={() => {
        console.log('✅ Empleado seleccionado:', { id, nombre, apellido });
        setEntradaManualForm(prev => ({
          ...prev,
          empleadoId: id,
          empleadoNombre: `${nombre} ${apellido}`.trim()
        }));
        setEmpleadoBusqueda('');
        setMostrarListaEmpleados(false);
      }}
      style={{
        width: '100%',
        padding: '0.75rem',
        textAlign: 'left',
        border: 'none',
        background: 'white',
        cursor: 'pointer',
        borderBottom: '1px solid #f3f4f6'
      }}
      onMouseOver={(e) => e.currentTarget.style.background = '#f9fafb'}
      onMouseOut={(e) => e.currentTarget.style.background = 'white'}
    >
      <div style={{ fontWeight: '500', color: '#111827' }}>
        {nombre} {apellido}
      </div>
      <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>
        {puesto}{departamento ? ` • ${departamento}` : ''}
      </div>
    </button>
  );
});
                      })()}
                        </div>
                      )}

                      {entradaManualForm.empleadoId && (
                        <div style={{
                          marginTop: '0.5rem',
                          padding: '0.75rem',
                          background: '#f0f9ff',
                          border: '1px solid #bae6fd',
                          borderRadius: '0.375rem'
                        }}>
                          <p style={{ fontSize: '0.875rem', color: '#0369a1', margin: 0 }}>
                            <Check size={14} style={{ verticalAlign:'-2px', marginRight:'0.35rem', flexShrink:0 }} />Seleccionado: <strong>{entradaManualForm.empleadoNombre}</strong>
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Tipo de Solicitud */}
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                      Tipo de Solicitud *
                    </label>
                    <select
                      value={entradaManualForm.tipoSolicitud}
                      onChange={(e) => setEntradaManualForm(prev => ({ ...prev, tipoSolicitud: e.target.value }))}
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '0.5rem',
                        fontSize: '1rem'
                      }}
                      required
                    >
                      <option value="vacaciones">Vacaciones</option>
                      <option value="permiso">Permiso del Año (3 días)</option>
                      <option value="cumpleaños">Permiso de Cumpleaños</option>
                     {/*  <option value="medico">Permiso Médico</option> */}
                      <option value="licencia">Licencia</option>
                    </select>
                  </div>

                  {/* Fechas */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
                    <div>
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                        Fecha de Inicio *
                      </label>
                      <input
                        type="date"
                        value={entradaManualForm.fechaInicio}
                        onChange={(e) => setEntradaManualForm(prev => ({ ...prev, fechaInicio: e.target.value }))}
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          border: '1px solid #d1d5db',
                          borderRadius: '0.5rem',
                          fontSize: '1rem'
                        }}
                        required
                      />
                    </div>

                    <div>
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                        Fecha de Fin *
                      </label>
                      <input
                        type="date"
                        value={entradaManualForm.fechaFin}
                        onChange={(e) => setEntradaManualForm(prev => ({ ...prev, fechaFin: e.target.value }))}
                        min={entradaManualForm.fechaInicio}
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          border: '1px solid #d1d5db',
                          borderRadius: '0.5rem',
                          fontSize: '1rem'
                        }}
                        required
                      />
                    </div>
                  </div>

                 {/* Cálculo de días */}
                  {entradaManualForm.fechaInicio && entradaManualForm.fechaFin && (() => {
                    const [aI, mI, dI] = entradaManualForm.fechaInicio.split("-");
                    const [aF, mF, dF] = entradaManualForm.fechaFin.split("-");

                    const inicio = new Date(aI, mI - 1, dI);
                    const fin = new Date(aF, mF - 1, dF);

                    if (fin < inicio) return null;

                    const diffTime = fin - inicio;
                    const dias = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;

                    let diasHabiles = 0;
                    let fechaActual = new Date(inicio);

                    while (fechaActual <= fin) {
                      const diaSemana = fechaActual.getDay();
                      if (diaSemana !== 0 && diaSemana !== 6) {
                        diasHabiles++;
                      }
                      fechaActual.setDate(fechaActual.getDate() + 1);
                    }

                    return dias > 0 ? (
                      <div style={{
                        background: '#f0f9ff',
                        border: '1px solid #bae6fd',
                        borderRadius: '0.5rem',
                        padding: '1rem',
                        marginBottom: '1.5rem'
                      }}>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
                          <div>
                            <p style={{ fontSize: '0.75rem', color: '#0369a1', margin: 0, fontWeight: '600' }}>
                              DÍAS TOTALES
                            </p>
                            <p style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#0369a1', margin: 0 }}>
                              {dias}
                            </p>
                          </div>
                          <div>
                            <p style={{ fontSize: '0.75rem', color: '#0369a1', margin: 0, fontWeight: '600' }}>
                              DÍAS HÁBILES
                            </p>
                            <p style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#0369a1', margin: 0 }}>
                              {diasHabiles}
                            </p>
                          </div>
                        </div>
                        <p style={{ fontSize: '0.75rem', color: '#0369a1', margin: 0, marginTop: '0.5rem' }}>
                          <AlertTriangle size={14} style={{ verticalAlign:'-2px', marginRight:'0.35rem', flexShrink:0 }} />Estos días serán descontados del balance del empleado
                        </p>
                      </div>
                    ) : null;
                  })()}

                  {/* Justificación */}
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                      Justificación / Motivo *
                    </label>
                    <textarea
                      value={entradaManualForm.justificacion}
                      onChange={(e) => setEntradaManualForm(prev => ({ ...prev, justificacion: e.target.value }))}
                      placeholder="Ejemplo: Empleado tomó vacaciones sin registrar, permiso verbal autorizado, etc."
                      rows={3}
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '0.5rem',
                        fontSize: '1rem',
                        resize: 'vertical'
                      }}
                      required
                    />
                  </div>

                  {/* Documento/Referencia */}
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                      Documento o Referencia (Opcional)
                    </label>
                    <input
                      type="text"
                      value={entradaManualForm.documentoReferencia}
                      onChange={(e) => setEntradaManualForm(prev => ({ ...prev, documentoReferencia: e.target.value }))}
                      placeholder="Número de documento, email de autorización, etc."
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '0.5rem',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  {/* Botón de envío */}
                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      background: loading ? '#9ca3af' : '#dc2626',
                      color: 'white',
                      padding: '0.75rem 1.5rem',
                      borderRadius: '0.5rem',
                      border: 'none',
                      fontSize: '1rem',
                      fontWeight: '500',
                      cursor: loading ? 'not-allowed' : 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}
                  >
                    <FileText style={{ width: '1rem', height: '1rem' }} />
                    {loading ? 'Registrando...' : 'Registrar y Descontar Días'}
                  </button>
                </form>
              </div>
                        
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VacacionesModule;
